import React from 'react';
import PropTypes from 'prop-types';

const Icon = ({ name, color, ...props }) => {
  switch (name) {
    case 'chevron-blue':
      return (
        <svg
          className={props.className}
          width='14'
          height='8'
          viewBox='0 0 14 8'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M1 1L6.952 7L13 1'
            stroke='#6071B5'
            stroke-width='1.5'
            stroke-linecap='round'
            stroke-linejoin='round'
          />
        </svg>
      );
    case 'chevron':
      return (
        <svg
          className={props.className}
          width='35px'
          height='35px'
          viewBox='0 0 35 35'
          version='1.1'
          xmlns='http://www.w3.org/2000/svg'
          xmlnsXlink='http://www.w3.org/1999/xlink'
        >
          <g
            id='Assets'
            stroke='none'
            stroke-width='1'
            fill='none'
            fill-rule='evenodd'
            stroke-linecap='round'
            stroke-linejoin='round'
          >
            <g
              transform='translate(-9.000000, -18.000000)'
              id='atom/ic/shevron_down'
              stroke='#FFFFFF'
              stroke-width='1.5'
            >
              <g transform='translate(17.000000, 26.000000)'>
                <polyline
                  id='Shape-3-Copy'
                  transform='translate(10.000000, 10.000000) rotate(-90.000000) translate(-10.000000, -10.000000) '
                  points='13 4 7 9.952 13 16'
                ></polyline>
              </g>
            </g>
          </g>
        </svg>
      );

    case 'scanbit':
      return (
        <svg
          className={props.className}
          width='24px'
          height='22px'
          viewBox='0 0 24 22'
          version='1.1'
          xmlns='http://www.w3.org/2000/svg'
          xmlnsXlink='http://www.w3.org/1999/xlink'
        >
          <g
            id='Assets'
            stroke='none'
            stroke-width='1'
            fill='none'
            fill-rule='evenodd'
          >
            <g
              transform='translate(-139.000000, -214.000000)'
              fill='#6071B5'
              id='atom/ic/scanbit'
            >
              <g transform='translate(139.000000, 213.000000)'>
                <path
                  d='M14.3427536,1.9671418 C14.3016171,1.96570584 14.0321286,1.96417244 13.5970302,1.96271437 C9.7678402,2.10977087 6.52891058,4.86146337 5.31366036,8.66842649 C5.31367921,8.67025301 5.31368866,8.67208188 5.31368866,8.67391304 C5.31368866,8.78282522 5.28025916,8.88360419 5.22350548,8.96572358 C4.94844539,9.92263762 4.8,10.9419286 4.8,12 C4.8,17.4384446 8.72180676,21.8523422 13.6009525,22.0374353 C14.0305364,22.0360272 14.2962831,22.0345481 14.3366604,22.0331627 C19.1703943,21.7933487 23.04,17.4021293 23.04,12 C23.04,6.60014084 19.1736458,2.21034207 14.3427536,1.9671418 Z M9.79090553,1.96148193 C7.65335524,2.03492729 5.69809229,2.91996991 4.17378606,4.34782609 L6.61813836,4.34782609 C6.63737047,4.34782609 6.6563384,4.34900428 6.67497927,4.35129516 C7.55910866,3.35385931 8.6148564,2.53826812 9.79090553,1.96148193 Z M3.25696568,5.33627935 C2.5851128,6.16962689 2.03708696,7.12709302 1.64505125,8.17391304 L4.46657211,8.17391304 C4.81402435,7.15184586 5.29669476,6.2011098 5.89105011,5.34782609 L3.36,5.34782609 C3.32463138,5.34782609 3.29015622,5.34384135 3.25696568,5.33627935 Z M1.3294764,9.16059404 C1.08905772,10.0605951 0.96,11.0134398 0.96,12 L3.84,12 C3.84,11.0233558 3.95672573,10.0760342 4.17587239,9.17391304 L1.44,9.17391304 C1.40196328,9.17391304 1.3649599,9.16930444 1.3294764,9.16059404 Z M1.00461194,13 C1.09360034,13.9919031 1.31356153,14.9409378 1.64505125,15.826087 L4.46657211,15.826087 C4.16287812,14.9327393 3.96248815,13.984896 3.88111685,13 L1.00461194,13 Z M2.08002307,16.826087 C2.41731292,17.5024909 2.82326192,18.13133 3.28743786,18.7013281 C3.31110223,18.6975902 3.33533384,18.6956522 3.36,18.6956522 L5.92149091,18.6956522 C5.51295311,18.1151279 5.15632867,17.4889354 4.85911562,16.8253974 C4.85069559,16.8258552 4.84221811,16.826087 4.83368866,16.826087 L2.08002307,16.826087 Z M4.220516,19.6956522 C5.73795771,21.0979822 7.67513591,21.9658211 9.79090553,22.0385181 C8.62983834,21.4690797 7.58602697,20.6668819 6.70885205,19.6867358 C6.6794769,19.6925885 6.6491511,19.6956522 6.61813836,19.6956522 L4.220516,19.6956522 Z M13.5849658,22.9940492 C13.2369538,22.9952027 12.7805353,22.9962394 12.223229,22.997232 C11.4126009,22.9986758 10.2735956,23 10.08,23 C4.69647076,23 0.314887877,18.4032064 0.0162362743,12.6294247 C0.00564588467,12.5881438 -6.39488462e-13,12.5447587 -6.39488462e-13,12.5 C-6.39488462e-13,12.4707821 0.00240588191,12.4421496 0.00702254151,12.4143056 C0.00235450748,12.2768255 1.76125781e-12,12.1387085 1.76125781e-12,12 C1.76125781e-12,5.934501 4.5022224,1 10.08,1 C10.274684,1 11.414589,1.00136268 12.2265236,1.00285008 C12.7795934,1.00386326 13.2334955,1.00492128 13.5808824,1.00609695 C13.6934571,1.002043 13.8065059,1 13.92,1 C19.4977776,1 24,5.934501 24,12 C24,18.065499 19.4977776,23 13.92,23 C13.807878,23 13.6961907,22.9980061 13.5849658,22.9940492 Z M13.92,19.0568605 C13.6549033,19.0568605 13.44,18.8427359 13.44,18.5785997 C13.44,18.3144635 13.6549033,18.1003388 13.92,18.1003388 C14.2285001,18.1003388 14.5318256,18.084789 14.8284486,18.053839 C15.0921035,18.0263289 15.3282206,18.2169877 15.3558307,18.4796873 C15.3834408,18.742387 15.1920887,18.9776485 14.9284338,19.0051586 C14.5983487,19.0396001 14.2616552,19.0568605 13.92,19.0568605 Z M18.7980952,17.5288241 C18.5896038,17.6919612 18.2878586,17.6558067 18.1241283,17.4480708 C17.9603979,17.2403348 17.9966839,16.9396829 18.2051752,16.7765458 C18.4377834,16.5945381 18.6517244,16.3954282 18.8457623,16.1800375 C19.022841,15.9834724 19.3263187,15.9671554 19.5235986,16.1435925 C19.7208786,16.3200296 19.7372549,16.6224078 19.5601762,16.8189729 C19.3287498,17.0758664 19.0741203,17.3128442 18.7980952,17.5288241 Z M21.1019826,13.0176999 C21.0841249,13.2812361 20.8552332,13.4804504 20.5907387,13.4626574 C20.3262442,13.4448644 20.1263055,13.216802 20.1441632,12.9532658 C20.1542999,12.8036728 20.1595895,12.6514407 20.1599755,12.4977522 C20.1599983,12.3334835 20.155714,12.1867646 20.1467816,12.0387488 C20.1308703,11.7750888 20.3324875,11.5484983 20.5971062,11.5326446 C20.861725,11.5167909 21.0891395,11.7176776 21.1050508,11.9813376 C21.1151568,12.1487987 21.1200009,12.3146915 21.119974,12.4990108 C21.119535,12.6744176 21.1135264,12.8473414 21.1019826,13.0176999 Z M19.8236379,8.09640757 C19.9690135,8.31728474 19.9071563,8.61376429 19.6854759,8.75861318 C19.4637956,8.90346208 19.1662379,8.84182899 19.0208623,8.62095183 C18.856156,8.37070451 18.675642,8.13277541 18.4807324,7.90890227 C18.3070206,7.70937685 18.3285348,7.40731849 18.5287858,7.23423605 C18.7290368,7.06115362 19.0321935,7.08258989 19.2059053,7.28211531 C19.4289902,7.53835058 19.6354228,7.81044215 19.8236379,8.09640757 Z M15.6887089,5.05874255 C15.9446803,5.12744846 16.0962864,5.38989958 16.0273307,5.64494355 C15.9583749,5.89998751 15.6949694,6.05104434 15.438998,5.98233843 C15.1536677,5.90575222 14.8626766,5.85083158 14.5675818,5.81820077 C14.3041027,5.78906594 14.114215,5.55262939 14.1434558,5.29010494 C14.1726965,5.02758049 14.4099929,4.83838082 14.6734719,4.86751564 C15.0172478,4.90552946 15.3563143,4.96952369 15.6887089,5.05874255 Z M10.7430537,5.60929736 C10.977755,5.48648988 11.2679351,5.57650836 11.3911891,5.81035926 C11.5144432,6.04421017 11.4240974,6.33333892 11.1893961,6.4561464 C10.9275308,6.5931675 10.6749213,6.74981007 10.433379,6.92480361 C10.2189701,7.08013952 9.91877474,7.03288112 9.76287397,6.81924901 C9.6069732,6.6056169 9.65440346,6.30650922 9.86881241,6.1511733 C10.1477878,5.94906002 10.439893,5.76792623 10.7430537,5.60929736 Z M7.32546733,9.40192474 C7.42644854,9.15770255 7.70701111,9.04128618 7.95212139,9.14190151 C8.19723166,9.24251684 8.31407136,9.52206288 8.21309015,9.76628508 C8.09940759,10.0412254 8.00310985,10.3243977 7.92498125,10.6141642 C7.85620201,10.8692555 7.59290112,11.0204933 7.33688224,10.9519632 C7.08086336,10.8834332 6.92907564,10.6210863 6.99785488,10.365995 C7.08664847,10.0366737 7.19614396,9.71469223 7.32546733,9.40192474 Z M6.95646809,14.3568458 C6.88825795,14.1016028 7.04063041,13.8395927 7.2968015,13.7716297 C7.55297259,13.7036667 7.81593553,13.855487 7.88414567,14.11073 C7.96136023,14.3996675 8.06004502,14.675228 8.17947604,14.9368531 C8.28923328,15.1772869 8.18259025,15.4608504 7.94128215,15.57021 C7.69997406,15.6795696 7.41537937,15.5733129 7.30562212,15.3328791 C7.16399135,15.0226233 7.04734537,14.6969094 6.95646809,14.3568458 Z M10.2489911,18.2747932 C10.010181,18.160119 9.90988705,17.8742648 10.0249783,17.6363199 C10.1400695,17.3983751 10.4269632,17.2984445 10.6657733,17.4131188 C10.9290477,17.5395405 11.2063003,17.6492758 11.4958911,17.7417054 C11.7483511,17.8222838 11.8874511,18.0915233 11.8065797,18.3430686 C11.7257082,18.5946139 11.4554897,18.7332099 11.2030297,18.6526315 C10.871463,18.5468043 10.5527974,18.420678 10.2489911,18.2747932 Z'
                  id='Combined-Shape'
                ></path>
              </g>
            </g>
          </g>
        </svg>
      );
    case 'groups':
      return (
        <svg
          className={props.className}
          width='24px'
          height='24px'
          viewBox='0 0 24 24'
          fill='currentColor'
          xmlns='http://www.w3.org/2000/svg'
          xmlnsXlink='http://www.w3.org/1999/xlink'
        >
          <g
            id='Assets'
            stroke='none'
            stroke-width='1'
            fill='none'
            fill-rule='evenodd'
          >
            <g
              transform='translate(-14.000000, -237.000000)'
              fill='currentColor'
              id='atom/ic/menu/scanteams'
            >
              <g transform='translate(14.000000, 237.000000)'>
                <path
                  d='M16.2743541,13.4066703 L16.0405065,13.8712291 L13.7106312,14.2031577 C13.6460555,14.2123575 13.586374,14.242172 13.5408261,14.2879854 C13.426443,14.4030351 13.4288441,14.5872133 13.5461891,14.6993591 L15.2321027,16.3105743 L14.8341125,18.5856468 C14.8230816,18.6487036 14.8335599,18.713567 14.8639252,18.7701954 C14.9401806,18.9124047 15.1195812,18.96708 15.2646275,18.8923161 L17.3485314,17.8181726 L18.7271415,18.5287741 C18.7846083,18.9270339 18.8191426,19.334479 18.8290899,19.7491629 C18.8299677,19.7857576 18.832819,19.9724237 18.6789527,19.9999894 L18.2014399,19.9999894 L4.27412099,20 L4.26703471,19.9999102 C4.11569347,19.9960731 3.99617979,19.872676 4.00009344,19.724295 C4.09486764,16.1310482 6.03579962,13.0849965 8.74427383,11.855161 C7.6630161,11.0590727 6.96358891,9.79143541 6.96358891,8.36363346 C6.96358891,5.95366525 8.95623053,4 11.4142785,4 C13.8723266,4 15.8649682,5.95366525 15.8649682,8.36363346 C15.8649682,9.79143541 15.165541,11.0590727 14.0842833,11.855161 C14.8921298,12.2219795 15.6316936,12.7503735 16.2743541,13.4066703 Z M17.3485314,17.0909004 L15.8705712,17.8527116 C15.798048,17.8900935 15.7083477,17.8627559 15.67022,17.7916513 C15.6550374,17.763337 15.6497982,17.7309053 15.6553136,17.699377 L15.9375789,16.0858349 L14.741884,14.943118 C14.6832115,14.8870451 14.682011,14.794956 14.7392025,14.7374311 C14.7619765,14.7145245 14.7918172,14.6996172 14.824105,14.6950173 L16.4765148,14.4596047 L17.2154949,12.9915556 C17.2517565,12.9195187 17.3407148,12.8899422 17.4141888,12.9254945 C17.4434465,12.9396516 17.4671283,12.9628701 17.4815679,12.9915556 L18.220548,14.4596047 L19.8729577,14.6950173 C19.9540411,14.706569 20.0102209,14.7803788 19.9984388,14.8598762 C19.9937471,14.8915324 19.9785425,14.9207895 19.9551788,14.943118 L18.7594838,16.0858349 L19.0417491,17.699377 C19.0555998,17.7785531 19.0013626,17.8537467 18.9206068,17.8673264 C18.8884494,17.872734 18.8553707,17.8675973 18.8264916,17.8527116 L17.3485314,17.0909004 Z'
                  id='Shape'
                ></path>
              </g>
            </g>
          </g>
        </svg>
      );
    case 'events':
      return (
        <svg
          className={props.className}
          width='24px'
          height='24px'
          viewBox='0 0 24 24'
          fill='currentColor'
          xmlns='http://www.w3.org/2000/svg'
          xmlnsXlink='http://www.w3.org/1999/xlink'
        >
          <g
            id='Assets'
            stroke='none'
            stroke-width='1'
            fill='none'
            fill-rule='evenodd'
          >
            <g
              transform='translate(-13.000000, -173.000000)'
              fill='currentColor'
              id='atom/ic/menu/events'
            >
              <g transform='translate(13.000000, 173.000000)'>
                <path
                  d='M13.2632144,12.4206038 L13.2632144,12.4206038 C12.7976079,12.4206038 12.4210893,12.7976025 12.4210893,13.2631522 C12.4210893,13.7278438 12.7985197,14.1052716 13.2632144,14.1052716 L13.2632144,14.1052716 C13.727909,14.1052716 14.1053394,13.7278438 14.1053394,13.2631522 C14.105393,12.7976025 13.7287672,12.4206038 13.2632144,12.4206038 Z M10.7368393,11.5789135 C11.2017485,11.5789135 11.5789643,11.2017002 11.5789643,10.7367941 C11.5789643,10.2715662 11.2017485,9.89478201 10.7368393,9.89478201 C10.2720373,9.89478201 9.89482153,10.2715662 9.89482153,10.7367941 C9.89482153,11.2017002 10.2720373,11.5789135 10.7368393,11.5789135 Z M13.2632144,9.89478201 L13.2632144,9.89478201 C12.7976079,9.89478201 12.4210893,10.2715662 12.4210893,10.7367941 C12.4210893,11.2017002 12.7976615,11.5789135 13.2632144,11.5789135 L13.2632144,11.5789135 C13.727909,11.5789135 14.1053394,11.2017002 14.1053394,10.7367941 C14.105393,10.2715662 13.7287672,9.89478201 13.2632144,9.89478201 Z M14.105393,5.68413149 L9.89482153,5.68413149 L9.89482153,7.36837024 L14.105393,7.36837024 L14.105393,5.68413149 Z M15.7896431,11.5789135 C16.2541232,11.5789135 16.6317681,11.2017002 16.6317681,10.7367941 C16.6317681,10.2715662 16.2549814,9.89478201 15.7896431,9.89478201 C15.3240366,9.89478201 14.947518,10.2715662 14.947518,10.7367941 C14.947518,11.2017002 15.3249484,11.5789135 15.7896431,11.5789135 Z M15.7896431,14.1052716 C16.2541232,14.1052716 16.6317681,13.7278438 16.6317681,13.2631522 C16.6317681,12.7976025 16.2549814,12.4210329 15.7896431,12.4210329 C15.3240366,12.4210329 14.947518,12.7976025 14.947518,13.2631522 C14.947518,13.7278438 15.3249484,14.1052716 15.7896431,14.1052716 Z M10.7368393,14.1052716 C11.2017485,14.1052716 11.5789643,13.7278438 11.5789643,13.2631522 C11.5789643,12.7976025 11.2021776,12.4206038 10.7368393,12.4206038 C10.2716082,12.4206038 9.89482153,12.7976025 9.89482153,13.2631522 C9.89482153,13.7278438 10.2720373,14.1052716 10.7368393,14.1052716 Z M8.21057148,16.6316834 C8.67537343,16.6316834 9.05269651,16.254041 9.05269651,15.789564 C9.05269651,15.3240143 8.67537343,14.9474446 8.21057148,14.9474446 C7.74534045,14.9474446 7.36844646,15.3240143 7.36844646,15.789564 C7.36844646,16.254041 7.74571589,16.6316834 8.21057148,16.6316834 Z M18.3158036,5.68413149 L17.4739467,5.68413149 L17.4739467,7.36837024 L18.3158036,7.36837024 L18.3158036,18.315654 L5.68425005,18.315654 L5.68425005,7.36842388 L6.5262678,7.36842388 L6.5262678,5.68413149 L5.68425005,5.68413149 C4.75410979,5.68413149 4,6.43796805 4,7.36842388 L4,18.3153322 C4,19.2460025 4.75410979,20 5.68425005,20 L18.31575,20 C19.2460511,20 20,19.2459489 20,18.3153322 L20,7.36842388 C20.0000536,6.43796805 19.2460511,5.68413149 18.3158036,5.68413149 Z M8.21057148,14.1052716 C8.67537343,14.1052716 9.05269651,13.7278438 9.05269651,13.2631522 C9.05269651,12.7976025 8.67537343,12.4206038 8.21057148,12.4206038 C7.74534045,12.4206038 7.36844646,12.7976025 7.36844646,13.2631522 C7.36844646,13.7278438 7.74571589,14.1052716 8.21057148,14.1052716 Z M8.21057148,11.5789135 C8.67537343,11.5789135 9.05269651,11.2017002 9.05269651,10.7367941 C9.05269651,10.2715662 8.67537343,9.89478201 8.21057148,9.89478201 C7.74534045,9.89478201 7.36844646,10.2715662 7.36844646,10.7367941 C7.36844646,11.2017002 7.74571589,11.5789135 8.21057148,11.5789135 Z M10.7368393,16.6316834 C11.2017485,16.6316834 11.5789643,16.254041 11.5789643,15.789564 C11.5789643,15.3240143 11.2017485,14.9474446 10.7368393,14.9474446 C10.2720373,14.9474446 9.89482153,15.3240143 9.89482153,15.789564 C9.89482153,16.254041 10.2720373,16.6316834 10.7368393,16.6316834 Z M8.21057148,7.36842388 C8.67537343,7.36842388 9.05269651,6.9912106 9.05269651,6.5263045 L9.05269651,4.84217301 C9.05269651,4.37678419 8.67580252,4 8.21057148,4 C7.74571589,4 7.36844646,4.37678419 7.36844646,4.84211938 L7.36844646,6.52625086 C7.36844646,6.9912106 7.74571589,7.36842388 8.21057148,7.36842388 Z M15.7896431,7.36842388 C16.2541232,7.36842388 16.6317681,6.9912106 16.6317681,6.5263045 L16.6317681,4.84217301 C16.6317681,4.37678419 16.2541232,4 15.7896431,4 C15.3240366,4 14.947518,4.37678419 14.947518,4.84211938 L14.947518,6.52625086 C14.947518,6.9912106 15.3249484,7.36842388 15.7896431,7.36842388 Z'
                  id='Shape'
                ></path>
              </g>
            </g>
          </g>
        </svg>
      );
    case 'payment':
      return (
        <svg
          className={props.className + ' bi bi-people-fill'}
          width='24px'
          height='24px'
          viewBox='0 0 24 24'
          fill='currentColor'
          xmlns='http://www.w3.org/2000/svg'
          xmlnsXlink='http://www.w3.org/1999/xlink'
        >
          <g
            id='Assets'
            stroke='none'
            stroke-width='1'
            fill='currentColor'
            fill-rule='evenodd'
          >
            <g
              transform='translate(-13.000000, -145.000000)'
              id='atom/ic/menu/bill'
            >
              <g transform='translate(13.000000, 145.000000)'>
                <path
                  d='M18.7274073,6.53162184 L16.4381283,6.53162184 L16.4381283,4.26936069 L18.7274073,6.53162184 Z M7.31554671,6.25323248 L7.31554671,18.6840627 L16.8035748,18.6840627 L16.8035748,20 L6,20 L6,6.25323248 L7.31554671,6.25323248 Z M8.2291631,17.74683 L8.2291631,4 L15.5245119,4 L15.5245119,7.46885458 L19,7.46885458 L19,17.74683 L16.8035748,17.7467675 L16.8035748,17.74683 L8.2291631,17.74683 Z M16.9742993,15.0707494 L16.9742993,14.1335166 L10.2221259,14.1335166 L10.2221259,15.0707494 L16.9742993,15.0707494 Z M16.9742993,12.2022236 L10.2221259,12.2022236 L10.2221259,13.1394563 L16.9742993,13.1394563 L16.9742993,12.2022236 Z M13.5242401,8.56988437 C13.8796978,8.7435536 13.9996556,8.85789599 13.9996556,9.02313012 C13.9996556,9.13109933 13.9725212,9.21982403 13.9210237,9.28446185 C13.8521675,9.36737571 13.7631204,9.40436516 13.6322905,9.40436516 C13.427549,9.40436516 13.2654735,9.3114854 13.1398512,8.85808344 L13.0852779,8.6611396 L12.4987971,9.02525452 L12.5205107,9.13331745 C12.6095274,9.57612868 12.9128176,9.91899966 13.3096316,10.0385593 L13.3096316,10.4421005 L13.9548884,10.4421005 L13.9548884,10.0358101 C14.1302114,9.98454347 14.2825113,9.88704002 14.4086208,9.74517423 C14.5880246,9.54582482 14.6789903,9.29995743 14.6789903,9.01438262 L14.6788381,9.00769702 C14.6649816,8.6749794 14.5475818,8.44163969 14.2992,8.2518813 C14.1457429,8.13263405 14.0560258,8.08483518 13.8855145,7.99742261 L13.6569581,7.87580104 C13.619104,7.85452586 13.5682764,7.81866108 13.5095613,7.7772354 L13.5050237,7.77401757 C13.4101599,7.69766434 13.3926794,7.6371191 13.3926794,7.54617629 C13.3926794,7.42027469 13.4848633,7.31786639 13.5981821,7.31786639 C13.7337019,7.31786639 13.8235104,7.35623045 13.9381997,7.56582693 L14.0176234,7.71097304 L14.5712445,7.34307795 L14.509149,7.21767621 C14.3775883,6.95203321 14.1915455,6.7770831 13.9548884,6.69598122 L13.9548884,6.28453605 L13.3096316,6.28453605 L13.3096316,6.69332573 C12.9529558,6.82166413 12.7133142,7.16834653 12.7133142,7.57679256 C12.7133142,7.84971473 12.8024832,8.06371621 12.9877341,8.23260555 C13.1478302,8.37400273 13.2737265,8.45310517 13.5242401,8.56988437 Z'
                  id='Combined-Shape'
                ></path>
              </g>
            </g>
          </g>
        </svg>
      );
    case 'faq':
      return (
        <svg
          className={props.className}
          width='24px'
          height='24px'
          viewBox='0 0 24 24'
          version='1.1'
          xmlns='http://www.w3.org/2000/svg'
          xmlnsXlink='http://www.w3.org/1999/xlink'
        >
          <g
            id='Assets'
            stroke='none'
            stroke-width='1'
            fill='none'
            fill-rule='evenodd'
          >
            <g
              transform='translate(-13.000000, -203.000000)'
              fill='#3F3F41'
              id='atom/ic/menu/faq'
            >
              <g transform='translate(13.000000, 203.000000)'>
                <g id='Group-5' transform='translate(4.000000, 4.000000)'>
                  <path
                    d='M8,16 C3.581722,16 0,12.418278 0,8 C0,3.581722 3.581722,0 8,0 C12.418278,0 16,3.581722 16,8 C16,12.418278 12.418278,16 8,16 Z M6.95405907,9.33333333 L6.95405907,10 L8.3751117,10 L8.3751117,9.46296296 C8.3751117,9.12312679 8.42771641,8.86343037 8.52511826,8.68311207 C8.62981796,8.48928339 8.86760573,8.2204239 9.23536104,7.88988914 C9.74515728,7.42013839 10.0762627,7.0802282 10.2411816,6.85346464 C10.4092374,6.62238794 10.5371708,6.37579173 10.624133,6.11453354 C10.7121554,5.85009006 10.7552287,5.55047935 10.7552287,5.21604938 C10.7552287,4.42509654 10.5149432,3.79100987 10.0298059,3.33689291 C9.54954092,2.88733668 8.88901354,2.66666667 8.06517018,2.66666667 C7.20491255,2.66666667 6.37956155,2.88501902 5.59393773,3.31939833 L5.33333333,3.46348912 L5.93284831,4.91147019 L6.25709441,4.73857608 C6.61377755,4.54838593 6.92554985,4.41923607 7.1900957,4.35035616 C7.45493498,4.28139986 7.72690078,4.24691358 8.00669064,4.24691358 C8.4102717,4.24691358 8.69899524,4.33664508 8.88681108,4.50462794 C9.06700228,4.66579132 9.15873743,4.89863053 9.15873743,5.22839506 C9.15873743,5.50987773 9.10335257,5.74043128 8.99610652,5.92538456 C8.88057144,6.12463285 8.56475819,6.46090695 8.05957957,6.91181189 C7.64450852,7.28734213 7.3556802,7.6502336 7.19414133,8.00783779 C7.03233596,8.36603192 6.95405907,8.80784943 6.95405907,9.33333333 Z M6.75522866,12.3357934 C6.75522866,12.6633055 6.85293012,12.9277961 7.06470646,13.1022806 C7.25270697,13.2571759 7.48651117,13.3333333 7.7524624,13.3333333 C8.04529922,13.3333333 8.29398158,13.2451206 8.4789582,13.062629 C8.66511592,12.8789721 8.75522866,12.6297957 8.75522866,12.3357934 C8.75522866,12.0360836 8.66707615,11.7847253 8.48190989,11.6017607 C8.2980837,11.4201202 8.04853145,11.3333333 7.7524624,11.3333333 C7.12517737,11.3333333 6.75522866,11.7061943 6.75522866,12.3357934 Z'
                    id='Combined-Shape'
                  ></path>
                </g>
              </g>
            </g>
          </g>
        </svg>
      );
    case 'settings':
      return (
        <svg
          className={props.className}
          width='24px'
          height='24px'
          viewBox='0 0 24 24'
          version='1.1'
          xmlns='http://www.w3.org/2000/svg'
          xmlnsXlink='http://www.w3.org/1999/xlink'
        >
          <g
            id='Assets'
            stroke='none'
            stroke-width='1'
            fill='none'
            fill-rule='evenodd'
          >
            <g
              transform='translate(-15.000000, -268.000000)'
              fill='#3F3F41'
              id='atom/ic/menu/settings'
            >
              <g transform='translate(15.000000, 268.000000)'>
                <path
                  d='M9.82338185,6.60473967 L9.82338185,4.8 C9.82338185,4.3581722 10.181554,4 10.6233818,4 L13.3766182,4 C13.818446,4 14.1766182,4.3581722 14.1766182,4.8 L14.1766182,6.60473967 C14.6807503,6.80929471 15.1496865,7.08278551 15.5717933,7.41355094 L17.1295431,6.51203504 C17.5119486,6.29072566 18.0013562,6.42131987 18.2226656,6.80372537 C18.2229416,6.80420232 18.2232171,6.80467956 18.2234922,6.80515708 L19.6015399,9.19770805 C19.8217364,9.58001074 19.6908698,10.0684128 19.309023,10.2893988 L17.7488385,11.1923238 C17.7854109,11.4562975 17.8043151,11.7259358 17.8043151,12 C17.8043151,12.2740642 17.7854109,12.5437025 17.7488385,12.8076762 L19.309023,13.7106012 C19.6908698,13.9315872 19.8217364,14.4199893 19.6015399,14.8022919 L18.2234922,17.1948429 C18.0029735,17.5777049 17.5138368,17.7093102 17.1309748,17.4887916 C17.1304973,17.4885165 17.1300201,17.488241 17.1295431,17.487965 L15.5717933,16.5864491 C15.1496865,16.9172145 14.6807503,17.1907053 14.1766182,17.3952603 L14.1766182,19.2 C14.1766182,19.6418278 13.818446,20 13.3766182,20 L10.6233818,20 C10.181554,20 9.82338185,19.6418278 9.82338185,19.2 L9.82338185,17.3952603 C9.31924969,17.1907053 8.85031353,16.9172145 8.42820672,16.5864491 L6.8704569,17.487965 C6.4880514,17.7092743 5.9986438,17.5786801 5.77733442,17.1962746 C5.7770584,17.1957977 5.77678286,17.1953204 5.77650782,17.1948429 L4.39846009,14.8022919 C4.17826359,14.4199893 4.30913019,13.9315872 4.69097702,13.7106012 L6.25116155,12.8076762 C6.21458905,12.5437025 6.19568492,12.2740642 6.19568492,12 C6.19568492,11.7259358 6.21458905,11.4562975 6.25116155,11.1923238 L4.69097702,10.2893988 C4.30913019,10.0684128 4.17826359,9.58001074 4.39846009,9.19770805 L5.77650782,6.80515708 C5.99702648,6.42229507 6.48616317,6.29068977 6.86902519,6.51120843 C6.86950271,6.51148347 6.86997995,6.51175901 6.8704569,6.51203504 L8.42820672,7.41355094 C8.85031353,7.08278551 9.31924969,6.80929471 9.82338185,6.60473967 Z M12,14.1818182 C13.202113,14.1818182 14.1766182,13.2049849 14.1766182,12 C14.1766182,10.7950151 13.202113,9.81818182 12,9.81818182 C10.797887,9.81818182 9.82338185,10.7950151 9.82338185,12 C9.82338185,13.2049849 10.797887,14.1818182 12,14.1818182 Z'
                  id='Combined-Shape'
                ></path>
              </g>
            </g>
          </g>
        </svg>
      );
    case 'logout':
      return (
        <svg
          className={props.className}
          width='24px'
          height='24px'
          viewBox='0 0 24 24'
          version='1.1'
          xmlns='http://www.w3.org/2000/svg'
          xmlnsXlink='http://www.w3.org/1999/xlink'
        >
          <g
            id='Assets'
            stroke='none'
            stroke-width='1'
            fill='none'
            fill-rule='evenodd'
          >
            <g
              transform='translate(-15.000000, -300.000000)'
              fill='#3F3F41'
              id='atom/ic/menu/sign_out'
            >
              <g transform='translate(15.000000, 300.000000)'>
                <path
                  d='M20.6206612,4.14975536 C20.8438017,4.23394029 21,4.44440261 21,4.67591117 L21,19.3451351 C21,19.5766436 20.8438017,19.7871059 20.5983471,19.8502446 L13.4801653,21.9759141 C13.1231405,22.0811453 12.7438017,21.8285905 12.7438017,21.4708045 L12.7438017,20.4816316 L9.26280992,20.4816316 C8.95041322,20.4816316 8.70495868,20.2501231 8.70495868,19.9554758 L8.70495868,13.7047448 L9.90991736,13.7047448 L9.90991736,19.3451351 L12.7884298,19.3451351 L12.7884298,4.65486493 L9.9322314,4.65486493 L9.9322314,10.2952552 L8.72727273,10.2952552 L8.72727273,4.0445242 C8.72727273,3.74987695 8.97272727,3.51836839 9.28512397,3.51836839 L12.7661157,3.51836839 L12.7661157,2.52919547 C12.7661157,2.17140953 13.1454545,1.91885474 13.5024793,2.0240859 L20.6206612,4.14975536 Z M15.131405,12.631387 C15.5107438,12.631387 15.8231405,12.3577859 15.8231405,12 C15.8231405,11.6632603 15.4884298,11.368613 15.131405,11.368613 C14.7743802,11.368613 14.4619835,11.6422141 14.4619835,12 C14.4619835,12.3367397 14.7520661,12.631387 15.131405,12.631387 Z M11.0497934,12.9470805 L6.67623967,12.9470805 L6.67623967,14.2098544 C6.67623967,14.5255479 6.29690083,14.6939177 6.02913223,14.5045016 L3.15061983,12.2946473 C2.94979339,12.1473236 2.94979339,11.8526764 3.15061983,11.7053527 L6.02913223,9.49549836 C6.29690083,9.30608227 6.67623967,9.47445213 6.67623967,9.79014561 L6.67623967,11.0529195 L11.0497934,11.0529195 C11.2283058,11.0529195 11.3845041,11.2002432 11.3845041,11.368613 L11.3845041,12.631387 C11.3845041,12.7997568 11.2283058,12.9470805 11.0497934,12.9470805 Z'
                  id='Combined-Shape'
                ></path>
              </g>
            </g>
          </g>
        </svg>
      );
    case 'plus':
      return (
        <svg
          className={props.className}
          xmlns='http://www.w3.org/2000/svg'
          width='20'
          height='21'
          viewBox='0 0 20 21'
          fill='none'
        >
          <g clipPath='url(#clip0_2033_21633)'>
            <path
              d='M10 4.66699V16.3337'
              stroke='#6071B5'
              stroke-width='1.4'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
            <path
              d='M4.16797 10.5H15.8346'
              stroke='#6071B5'
              stroke-width='1.4'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
          </g>
          <defs>
            <clipPath id='clip0_2033_21633'>
              <rect
                width='20'
                height='20'
                fill='white'
                transform='translate(0 0.5)'
              />
            </clipPath>
          </defs>
        </svg>
      );
    case 'minus':
      return (
        <svg
          className={props.className}
          xmlns='http://www.w3.org/2000/svg'
          width='20'
          height='21'
          viewBox='0 0 20 21'
          fill='none'
        >
          <g clipPath='url(#clip0_2033_21628)'>
            <path
              d='M4.16797 10.5H15.8346'
              stroke='#6071B5'
              stroke-width='1.4'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
          </g>
          <defs>
            <clipPath id='clip0_2033_21628'>
              <rect
                width='20'
                height='20'
                fill='white'
                transform='translate(0 0.5)'
              />
            </clipPath>
          </defs>
        </svg>
      );

    case 'save':
      return (
        <svg
          className={props.className}
          width='20px'
          height='20px'
          viewBox='0 0 20 20'
          version='1.1'
          xmlns='http://www.w3.org/2000/svg'
          xmlnsXlink='http://www.w3.org/1999/xlink'
        >
          <g
            id='Assets'
            stroke='none'
            stroke-width='1'
            fill='none'
            fill-rule='evenodd'
          >
            <g
              transform='translate(-640.000000, -46.000000)'
              fill='#FFFFFF'
              id='atom/ic/save'
            >
              <g transform='translate(640.000000, 46.000000)'>
                <path
                  d='M16.0718423,1.28564142 L18.6997798,3.85994759 C18.8917927,4.04804183 19,4.30551558 19,4.57430617 L19,18 C19,18.5522847 18.5522847,19 18,19 L2,19 C1.44771525,19 1,18.5522847 1,18 L1,2 C1,1.44771525 1.44771525,1 2,1 L15.3720624,1 C15.6337085,1 15.8849332,1.10254679 16.0718423,1.28564142 Z M14.125,1.73469388 L5.125,1.73469388 L5.125,6.87755102 L14.125,6.87755102 L14.125,1.73469388 Z M4.375,18.2653061 L15.25,18.2653061 L15.25,11.2857143 L4.375,11.2857143 L4.375,18.2653061 Z M18.25,18.2653061 L18.25,4.45820408 L15.46975,1.73469388 L14.875,1.73469388 L14.875,6.6122449 C14.875,7.16452965 14.4272847,7.6122449 13.875,7.6122449 L5.375,7.6122449 C4.82271525,7.6122449 4.375,7.16452965 4.375,6.6122449 L4.375,1.73469388 L1.75,1.73469388 L1.75,18.2653061 L3.625,18.2653061 L3.625,11.5510204 C3.625,10.9987357 4.07271525,10.5510204 4.625,10.5510204 L15,10.5510204 C15.5522847,10.5510204 16,10.9987357 16,11.5510204 L16,18.2653061 L18.25,18.2653061 Z M5.875,13.122449 C5.667625,13.122449 5.5,12.9582449 5.5,12.755102 C5.5,12.5519592 5.667625,12.3877551 5.875,12.3877551 L8.5,12.3877551 C8.707375,12.3877551 8.875,12.5519592 8.875,12.755102 C8.875,12.9582449 8.707375,13.122449 8.5,13.122449 L5.875,13.122449 Z M9.625,13.8571429 C9.832375,13.8571429 10,14.0213469 10,14.2244898 C10,14.4276327 9.832375,14.5918367 9.625,14.5918367 L5.875,14.5918367 C5.667625,14.5918367 5.5,14.4276327 5.5,14.2244898 C5.5,14.0213469 5.667625,13.8571429 5.875,13.8571429 L9.625,13.8571429 Z M10.48375,13.9636735 C10.6225,13.8277551 10.8775,13.8277551 11.01625,13.9636735 C11.08375,14.033102 11.125,14.1289796 11.125,14.2244898 C11.125,14.32 11.08375,14.4155102 11.01625,14.4853061 C10.945,14.5514286 10.8475,14.5918367 10.75,14.5918367 C10.648375,14.5918367 10.554625,14.5514286 10.48375,14.4853061 C10.415875,14.4155102 10.375,14.32 10.375,14.2244898 C10.375,14.1289796 10.415875,14.033102 10.48375,13.9636735 Z M13.375,2.96938776 L13.375,5.64285714 C13.375,5.91899952 13.1511424,6.14285714 12.875,6.14285714 L11.625,6.14285714 C11.3488576,6.14285714 11.125,5.91899952 11.125,5.64285714 L11.125,2.96938776 C11.125,2.69324538 11.3488576,2.46938776 11.625,2.46938776 L12.875,2.46938776 C13.1511424,2.46938776 13.375,2.69324538 13.375,2.96938776 Z M12.625,5.40816327 L12.625,3.20408163 L11.875,3.20408163 L11.875,5.40816327 L12.625,5.40816327 Z'
                  id='Shape'
                ></path>
              </g>
            </g>
          </g>
        </svg>
      );

    case 'trash':
      return (
        <svg
          className={props.className}
          width='20px'
          height='20px'
          viewBox='0 0 20 20'
          version='1.1'
          xmlns='http://www.w3.org/2000/svg'
          xmlnsXlink='http://www.w3.org/1999/xlink'
        >
          <g
            id='Assets'
            stroke='none'
            stroke-width='1'
            fill='none'
            fill-rule='evenodd'
          >
            <g
              transform='translate(-617.000000, -46.000000)'
              fill='#FFFFFF'
              id='atom/ic/delete'
            >
              <g transform='translate(617.000000, 46.000000)'>
                <path
                  d='M12.3817539,7.7968698 C12.6047279,7.7968698 12.785441,7.96460935 12.785441,8.17157591 L12.785441,15.2535213 C12.785441,15.4603415 12.6047279,15.6282274 12.3817539,15.6282274 C12.1587798,15.6282274 11.9780668,15.4603415 11.9780668,15.2535213 L11.9780668,8.17157591 C11.9780668,7.96460935 12.1587798,7.7968698 12.3817539,7.7968698 Z M7.61824619,7.7968698 C7.84122021,7.7968698 8.02193328,7.96460935 8.02193328,8.17157591 L8.02193328,15.2535213 C8.02193328,15.4603415 7.84122021,15.6282274 7.61824619,15.6282274 C7.39527213,15.6282274 7.2145591,15.4603415 7.2145591,15.2535213 L7.2145591,8.17157591 C7.2145591,7.96460935 7.39527213,7.7968698 7.61824619,7.7968698 Z M4.1465372,6.76335426 C3.39798147,6.5789286 2.9129262,5.90767772 3.01305949,5.19471152 C3.11335055,4.48189171 3.76760747,3.94866735 4.54218208,3.94852099 L6.60902846,3.94852099 L6.60902846,3.48013836 C6.6066631,3.08625783 6.77444554,2.70803885 7.0748455,2.4297903 C7.37524545,2.15168811 7.78334787,1.9968291 8.2076924,2.00004923 L11.7923076,2.00004923 C12.2166522,1.9968291 12.6247546,2.15168811 12.9251545,2.4297903 C13.2255545,2.70803885 13.3933369,3.08625783 13.3909716,3.48013836 L13.3909716,3.94852099 L15.457818,3.94852099 C16.2323926,3.94866735 16.8866495,4.48189171 16.9869405,5.19471152 C17.0870738,5.90767772 16.6020186,6.5789286 15.8534629,6.76335426 L15.8534629,15.9953223 C15.8534629,16.5409881 15.6379003,17.053428 15.2613359,17.4211083 C14.8866638,17.7898133 14.3650244,17.9991218 13.818943,18 L6.18105705,18 C5.63513335,17.9991218 5.11349389,17.7898133 4.73866413,17.4211083 C4.36209977,17.053428 4.1465372,16.5409881 4.1465372,15.9953223 L4.1465372,6.76335426 Z M13.818943,17.2505878 C14.5091533,17.2505878 15.0460887,16.7002382 15.0460887,15.9953223 L15.0460887,6.7962874 L4.95391138,6.7962874 L4.95391138,15.9953223 C4.95391138,16.7002382 5.49084674,17.2505878 6.18105705,17.2505878 L13.818943,17.2505878 Z M7.41640264,3.48013836 L7.41640264,3.94852099 L12.5835974,3.94852099 L12.5835974,3.48013836 C12.5862782,3.28502772 12.5036484,3.09708919 12.3544734,2.95950179 C12.2054561,2.82176804 12.0026664,2.74609494 11.7923076,2.74946145 L8.2076924,2.74946145 C7.99733356,2.74609494 7.79454389,2.82176804 7.6455266,2.95950179 C7.49635158,3.09723555 7.41372188,3.28502772 7.41640264,3.48013836 Z M4.54218208,4.6979332 C4.14086031,4.6979332 3.81554531,4.99989364 3.81554531,5.3724042 C3.81554531,5.74491475 4.14086031,6.04687519 4.54218208,6.04687519 L15.457818,6.04687519 C15.8591397,6.04687519 16.1844547,5.74491475 16.1844547,5.3724042 C16.1844547,4.99989364 15.8591397,4.6979332 15.457818,4.6979332 L4.54218208,4.6979332 Z M10,7.7968698 C10.2229741,7.7968698 10.4036871,7.96460935 10.4036871,8.17157591 L10.4036871,15.2535213 C10.4036871,15.4603415 10.2229741,15.6282274 10,15.6282274 C9.77702597,15.6282274 9.59631294,15.4603415 9.59631294,15.2535213 L9.59631294,8.17157591 C9.59631294,7.96460935 9.77702597,7.7968698 10,7.7968698 Z'
                  id='Shape'
                ></path>
              </g>
            </g>
          </g>
        </svg>
      );
    case 'check':
      return (
        <svg
          className={props.className}
          width='24px'
          height='24px'
          viewBox='0 0 24 24'
          version='1.1'
          xmlns='http://www.w3.org/2000/svg'
          xmlnsXlink='http://www.w3.org/1999/xlink'
        >
          <desc>Created with Sketch.</desc>
          <g
            id='Assets'
            stroke='none'
            stroke-width='3'
            fill='none'
            fill-rule='evenodd'
            stroke-linecap='round'
            stroke-linejoin='round'
          >
            <g
              transform='translate(-73.000000, -60.000000)'
              id='atom/ic/tick'
              stroke='#6071B5'
            >
              <g transform='translate(75.000000, 62.000000)'>
                <polyline
                  id='Tick'
                  points='4 9.19501097 8.50292212 14 16 6'
                ></polyline>
              </g>
            </g>
          </g>
        </svg>
      );
    case 'copy-pink':
      return (
        <svg
          className={props.className}
          width='20px'
          height='20px'
          viewBox='0 0 20 20'
          version='1.1'
          xmlns='http://www.w3.org/2000/svg'
          xmlnsXlink='http://www.w3.org/1999/xlink'
        >
          <g
            id='Assets'
            stroke='none'
            stroke-width='1'
            fill='none'
            fill-rule='evenodd'
          >
            <g transform='translate(-22.000000, -345.000000)' id='atom/btn/add'>
              <g transform='translate(22.000000, 345.000000)'>
                <rect
                  id='Rectangle'
                  fill='#6071B5'
                  x='0'
                  y='0'
                  width='20'
                  height='20'
                  rx='2'
                ></rect>
                <g id='atom/ic/link' fill='#FFFFFF'>
                  <path
                    d='M16.9066482,8.06138645 C16.9664278,8.12114741 17.0000319,8.20223108 17,8.28675697 L17,17.6812749 C17,17.8573068 16.8572303,18 16.6811754,18 L8.32248874,18 C8.14643383,18 8.0036642,17.8573068 8.0036642,17.6812749 L8.0036642,14.2779602 L3.31882454,14.2779602 C3.14276963,14.2779602 3,14.1352669 3,13.9592351 L3,2.3187251 C3,2.14269323 3.14276963,2 3.31882454,2 L9.4307866,2 C9.51540263,2 9.59644783,2.03359363 9.65629119,2.09335458 L11.9029521,4.33934661 C11.9627317,4.39910757 11.9963358,4.48019124 11.9963358,4.56471713 L11.9963358,5.72203984 L14.4344827,5.72203984 C14.5190349,5.72203984 14.600112,5.75563347 14.6599235,5.81539442 L16.9066482,8.06138645 Z M14.7533391,6.81023108 L14.7533391,7.96803187 L15.9115011,7.96803187 L14.7533391,6.81023108 Z M9.74964302,3.08819124 L9.74964302,4.24599203 L10.907805,4.24599203 L9.74964302,3.08819124 Z M4.78044376,5.72203984 L11.3586867,5.72203984 L11.3586867,4.88344223 L9.4307866,4.88344223 C9.25473169,4.88344223 9.11196206,4.740749 9.11196206,4.56471713 L9.11196206,2.6374502 L3.63764908,2.6374502 L3.63764908,13.64051 L8.00372796,13.64051 L8.00372796,11.1383904 L4.78044376,11.1383904 C4.60438884,11.1383904 4.46161922,10.9956972 4.46161922,10.8196653 C4.46161922,10.6436335 4.60438884,10.5009402 4.78044376,10.5009402 L8.00372796,10.5009402 L8.00372796,9.54447809 L4.78044376,9.54447809 C4.60438884,9.54447809 4.46161922,9.40178486 4.46161922,9.22575299 C4.46161922,9.04972112 4.60438884,8.90702789 4.78044376,8.90702789 L8.00372796,8.90702789 L8.00372796,7.95053386 L4.78044376,7.95053386 C4.60438884,7.95053386 4.46161922,7.80784064 4.46161922,7.63180876 C4.46161922,7.45577689 4.60438884,7.31308367 4.78044376,7.31308367 L8.00372796,7.31308367 L8.00372796,6.35949004 L4.78044376,6.35949004 C4.60438884,6.35949004 4.46161922,6.21679681 4.46161922,6.04076494 C4.46161922,5.86473307 4.60438884,5.72203984 4.78044376,5.72203984 Z M16.3624147,17.3625498 L16.3624147,8.60548207 L14.4345146,8.60548207 C14.2584596,8.60548207 14.11569,8.46278884 14.11569,8.28675697 L14.11569,6.35949004 L8.64137704,6.35949004 L8.64137704,17.3625498 L16.3624147,17.3625498 Z M9.78413983,10.0786614 C9.60805304,10.0786614 9.4653153,9.93596813 9.4653153,9.75993625 C9.4653153,9.58390438 9.60808492,9.44121116 9.78413983,9.44121116 L13.7822314,9.44121116 C13.9582863,9.44121116 14.101056,9.58390438 14.101056,9.75993625 C14.101056,9.93596813 13.9582863,10.0786614 13.7822314,10.0786614 L9.78413983,10.0786614 Z M15.21962,11.0351554 C15.3957068,11.0351554 15.5384764,11.1778486 15.5384764,11.3538805 C15.5384764,11.5299124 15.3957068,11.6726056 15.2196519,11.6726056 L9.78413983,11.6726056 C9.60808492,11.6726056 9.4653153,11.5299124 9.4653153,11.3538805 C9.4653153,11.1778486 9.60808492,11.0351554 9.78413983,11.0351554 L15.21962,11.0351554 Z M15.21962,12.6290677 C15.3957068,12.6290677 15.5384764,12.771761 15.5384764,12.9477928 C15.5384764,13.1238247 15.3957068,13.2665179 15.2196519,13.2665179 L9.78413983,13.2665179 C9.60808492,13.2665179 9.4653153,13.1238247 9.4653153,12.9477928 C9.4653153,12.771761 9.60808492,12.6290677 9.78413983,12.6290677 L15.21962,12.6290677 Z M15.21962,14.223012 C15.3957068,14.223012 15.5384764,14.3657052 15.5384764,14.5417371 C15.5384764,14.7177689 15.3957068,14.8604622 15.2196519,14.8604622 L9.78413983,14.8604622 C9.60808492,14.8604622 9.4653153,14.7177689 9.4653153,14.5417371 C9.4653153,14.3657052 9.60808492,14.223012 9.78413983,14.223012 L15.21962,14.223012 Z M14.6881395,10.0786614 C14.5120846,10.0786614 14.3693149,9.93596813 14.3693149,9.75993625 C14.3693149,9.58390438 14.5120846,9.44121116 14.6881395,9.44121116 L15.21962,9.44121116 C15.3956749,9.44121116 15.5384445,9.58390438 15.5384445,9.75993625 C15.5384445,9.93596813 15.3956749,10.0786614 15.21962,10.0786614 L14.6881395,10.0786614 Z'
                    id='Shape'
                  ></path>
                </g>
              </g>
            </g>
          </g>
        </svg>
      );
    case 'refresh':
      return (
        <svg
          className={props.className}
          width='20px'
          height='20px'
          viewBox='0 0 20 20'
          version='1.1'
          xmlns='http://www.w3.org/2000/svg'
          xmlnsXlink='http://www.w3.org/1999/xlink'
        >
          <g
            id='Assets'
            stroke='none'
            stroke-width='1'
            fill='none'
            fill-rule='evenodd'
          >
            <g
              transform='translate(-54.000000, -345.000000)'
              fill='#FFFFFF'
              id='atom/ic/refresh'
            >
              <g transform='translate(54.000000, 345.000000)'>
                <path
                  d='M16.9231343,0 C17.3055004,0 17.6154579,0.303805653 17.6154984,0.678543029 L17.6154984,4.74996024 C17.6164314,5.04287167 17.4254918,5.30337876 17.1419421,5.39593988 L12.9880818,6.7530657 C12.6248625,6.87151054 12.2324768,6.67887366 12.1116335,6.32286322 C11.9907903,5.96685277 12.1873279,5.58225493 12.5505473,5.46381009 L15.6174673,4.46158144 C14.1752178,2.91726586 12.1375952,2.03757732 10.0015618,2.03717972 C5.79565651,2.03634476 2.38547512,5.37757079 2.38462326,9.49996024 C2.38462326,9.87473738 2.07470634,10.178543 1.69234025,10.178543 C1.30997417,10.178543 1.00001668,9.87473738 1.00001668,9.49996024 C0.995513961,7.2083567 1.90275112,5.00529853 3.52900366,3.35887944 C6.97975008,-0.134627136 12.6665228,-0.224882185 16.2308107,3.1573761 L16.2308107,0.678582789 C16.2308107,0.303805653 16.5407682,0 16.9231343,0 Z M18.3077409,8.82141721 C18.690107,8.82141721 19.0000644,9.12522286 18.9999833,9.5 C19.004486,11.7916035 18.0972489,13.9946617 16.4709963,15.6410808 C13.0202905,19.1346271 7.33347725,19.2248424 3.76918927,15.8425841 L3.76918927,18.3214172 C3.76918927,18.6961943 3.45923179,19 3.0768657,19 C2.69449961,19 2.38454213,18.6961943 2.38454213,18.3214172 L2.38454213,14.25 C2.38360913,13.9570886 2.57454878,13.6965815 2.85809843,13.6040204 L7.01195873,12.2468945 C7.37517811,12.1284497 7.76756376,12.3210866 7.88840702,12.677097 C8.00925028,13.0331075 7.81271265,13.4177053 7.44949327,13.5361502 L4.38257327,14.5383788 C5.82482277,16.0826944 7.8624454,16.9623829 9.99847881,16.9627805 C14.2043841,16.9636155 17.6145654,13.6223894 17.6154173,9.5 C17.6154173,9.12522286 17.9253748,8.82141721 18.3077409,8.82141721 Z'
                  id='Combined-Shape'
                ></path>
              </g>
            </g>
          </g>
        </svg>
      );
    case 'download':
      return (
        <svg
          className={props.className}
          width='24px'
          height='24px'
          viewBox='0 0 24 24'
          version='1.1'
          xmlns='http://www.w3.org/2000/svg'
          xmlnsXlink='http://www.w3.org/1999/xlink'
        >
          <title>btn_download</title>
          <desc>Created with Sketch.</desc>
          <g
            id='Assets'
            stroke='none'
            stroke-width='1'
            fill='none'
            fill-rule='evenodd'
          >
            <g transform='translate(-42.000000, -300.000000)' id='atom/btn/add'>
              <g transform='translate(44.000000, 302.000000)'>
                <rect
                  id='Rectangle'
                  fill='#B3B3B3'
                  x='0'
                  y='0'
                  width='20'
                  height='20'
                  rx='2'
                ></rect>
                <g
                  id='atom/ic/download'
                  stroke='#FFFFFF'
                  stroke-linecap='round'
                  stroke-linejoin='round'
                  stroke-width='1'
                >
                  <g id='Group' transform='translate(3.000000, 3.000000)'>
                    <polyline
                      id='Path'
                      stroke-width='1.5'
                      points='7 0 7 9.90909091 9.8 6.75741769 7 9.90909091 4.2 6.75741769'
                    ></polyline>
                    <path
                      d='M0,8.54545455 L-2.22044605e-16,12.6 C-1.2735508e-16,13.3731986 0.62680135,14 1.4,14 L12.6,14 C13.3731986,14 14,13.3731986 14,12.6 L14,8.54545455'
                      id='Path-2'
                      stroke-width='1.5'
                    ></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      );
    case 'excel':
      return (
        <svg
          className={props.className}
          width='21px'
          height='19px'
          viewBox='0 0 21 19'
          version='1.1'
          xmlns='http://www.w3.org/2000/svg'
          xmlnsXlink='http://www.w3.org/1999/xlink'
        >
          <title>ic_exscel</title>
          <desc>Created with Sketch.</desc>
          <g
            id='Desktop'
            stroke='none'
            stroke-width='1'
            fill='none'
            fill-rule='evenodd'
          >
            <g id='ic_exscel' fill='#3F3F41' fill-rule='nonzero'>
              <path
                d='M20.34375,2.56267427 L11.8125,2.56267427 L11.8125,0.670558091 C11.8125,0.482607884 11.725875,0.304748963 11.5749375,0.184914938 C11.4253125,0.0650809129 11.2245,0.0133630705 11.0355,0.0512053942 L0.5355,1.94332158 C0.2244375,1.99882365 0,2.25867427 0,2.56267427 L0,16.4381929 C0,16.7409315 0.2244375,17.0020436 0.5355,17.0575456 L11.0355,18.9496618 C11.074875,18.9572303 11.1155625,18.9610145 11.15625,18.9610145 C11.3085,18.9610145 11.4568125,18.9105581 11.5749375,18.8159523 C11.725875,18.6961183 11.8125,18.5169979 11.8125,18.3303091 L11.8125,16.4381929 L20.34375,16.4381929 C20.706,16.4381929 21,16.1556369 21,15.8074876 L21,3.19337967 C21,2.84523029 20.706,2.56267427 20.34375,2.56267427 Z M9.02475,11.608251 C9.263625,11.8693631 9.2360625,12.2679689 8.9630625,12.4975456 C8.838375,12.6022427 8.6848125,12.6539606 8.53125,12.6539606 C8.3488125,12.6539606 8.1676875,12.5807988 8.03775,12.4382593 L6.129375,10.343056 L4.4559375,12.4117697 C4.326,12.5707075 4.13175,12.6539606 3.9375,12.6539606 C3.7970625,12.6539606 3.6553125,12.6110726 3.5345625,12.5215124 C3.2484375,12.3070726 3.19725,11.9109896 3.4190625,11.6360021 L5.2486875,9.37555394 L3.444,7.39261618 C3.205125,7.13150415 3.2326875,6.73289834 3.5056875,6.50332158 C3.777375,6.27374481 4.1908125,6.29897303 4.4323125,6.56260788 L6.0703125,8.36137967 L8.014125,5.95965353 C8.23725,5.68592739 8.649375,5.63547095 8.9355,5.84991079 C9.221625,6.06308921 9.2728125,6.4591722 9.0496875,6.73542116 L6.9496875,9.32888174 L9.02475,11.608251 Z M19.6875,15.1767822 L11.8125,15.1767822 L11.8125,13.9153714 L13.78125,13.9153714 C14.1435,13.9153714 14.4375,13.6328154 14.4375,13.284666 C14.4375,12.9365166 14.1435,12.6539606 13.78125,12.6539606 L11.8125,12.6539606 L11.8125,11.3925498 L13.78125,11.3925498 C14.1435,11.3925498 14.4375,11.1099938 14.4375,10.7618444 C14.4375,10.413695 14.1435,10.131139 13.78125,10.131139 L11.8125,10.131139 L11.8125,8.86972822 L13.78125,8.86972822 C14.1435,8.86972822 14.4375,8.5871722 14.4375,8.23902282 C14.4375,7.89087344 14.1435,7.60831743 13.78125,7.60831743 L11.8125,7.60831743 L11.8125,6.34690664 L13.78125,6.34690664 C14.1435,6.34690664 14.4375,6.06435062 14.4375,5.71620124 C14.4375,5.36805187 14.1435,5.08549585 13.78125,5.08549585 L11.8125,5.08549585 L11.8125,3.82408506 L19.6875,3.82408506 L19.6875,15.1767822 Z'
                id='Shape'
              ></path>
              <path
                d='M17.71875,5.08549585 L16.40625,5.08549585 C16.044,5.08549585 15.75,5.36805187 15.75,5.71620124 C15.75,6.06435062 16.044,6.34690664 16.40625,6.34690664 L17.71875,6.34690664 C18.081,6.34690664 18.375,6.06435062 18.375,5.71620124 C18.375,5.36805187 18.081,5.08549585 17.71875,5.08549585 Z'
                id='Path'
              ></path>
              <path
                d='M17.71875,7.60831743 L16.40625,7.60831743 C16.044,7.60831743 15.75,7.89087344 15.75,8.23902282 C15.75,8.5871722 16.044,8.86972822 16.40625,8.86972822 L17.71875,8.86972822 C18.081,8.86972822 18.375,8.5871722 18.375,8.23902282 C18.375,7.89087344 18.081,7.60831743 17.71875,7.60831743 Z'
                id='Path'
              ></path>
              <path
                d='M17.71875,10.131139 L16.40625,10.131139 C16.044,10.131139 15.75,10.413695 15.75,10.7618444 C15.75,11.1099938 16.044,11.3925498 16.40625,11.3925498 L17.71875,11.3925498 C18.081,11.3925498 18.375,11.1099938 18.375,10.7618444 C18.375,10.413695 18.081,10.131139 17.71875,10.131139 Z'
                id='Path'
              ></path>
              <path
                d='M17.71875,12.6539606 L16.40625,12.6539606 C16.044,12.6539606 15.75,12.9365166 15.75,13.284666 C15.75,13.6328154 16.044,13.9153714 16.40625,13.9153714 L17.71875,13.9153714 C18.081,13.9153714 18.375,13.6328154 18.375,13.284666 C18.375,12.9365166 18.081,12.6539606 17.71875,12.6539606 Z'
                id='Path'
              ></path>
            </g>
          </g>
        </svg>
      );

    case 'stats':
      return (
        <svg
          className={props.className}
          width='20px'
          height='20px'
          viewBox='0 0 20 20'
          version='1.1'
          xmlns='http://www.w3.org/2000/svg'
          xmlnsXlink='http://www.w3.org/1999/xlink'
        >
          <g
            id='Desktop'
            stroke='none'
            stroke-width='1'
            fill='none'
            fill-rule='evenodd'
          >
            <g
              id='05--01-09---List-of-tickets-Hover'
              transform='translate(-1472.000000, -506.000000)'
              fill='#6071B5'
              fill-rule='nonzero'
            >
              <g
                id='Group-3-Copy'
                transform='translate(1472.000000, 506.000000)'
              >
                <g id='Group-4'>
                  <g id='ic_statistics'>
                    <path
                      d='M5.09090909,5.41577825 L0.648760331,5.41577825 C0.289256198,5.41577825 0,5.71428571 0,6.08528785 L0,19.3304904 C0,19.7014925 0.289256198,20 0.648760331,20 L5.09090909,20 C5.45041322,20 5.73971254,19.7014925 5.73971254,19.3304904 L5.73971254,6.08528785 C5.74380165,5.71428571 5.45041322,5.41577825 5.09090909,5.41577825 Z M4.44214876,18.6609808 L1.29752066,18.6609808 L1.29752066,6.75479744 L4.44214876,6.75479744 L4.44214876,18.6609808 Z'
                      id='Shape'
                    ></path>
                    <path
                      d='M19.3429752,8.92963753 L14.9008264,8.92963753 C14.5413223,8.92963753 14.2520661,9.22814499 14.2520661,9.59914712 L14.2520661,19.3304904 C14.2520661,19.7014925 14.5413223,20 14.9008264,20 L19.3429752,20 C19.7024793,20 19.9917355,19.7014925 19.9917355,19.3304904 L19.9917355,9.59914712 C19.9917355,9.22814499 19.7024793,8.92963753 19.3429752,8.92963753 Z M15.5495868,10.2686567 L16.5578512,10.2686567 L15.5495868,11.3091684 L15.5495868,10.2686567 Z M15.5495868,12.3752665 L17.5867769,10.2729211 L18.6157025,10.2729211 L15.5495868,13.4371002 L15.5495868,12.3752665 L15.5495868,12.3752665 Z M18.6942149,18.6609808 L17.6818182,18.6609808 L18.6942149,17.6162047 L18.6942149,18.6609808 Z M18.6942149,16.554371 L16.6528926,18.6609808 L15.6239669,18.6609808 L18.6900826,15.4968017 L18.6900826,16.554371 L18.6942149,16.554371 L18.6942149,16.554371 Z M18.6942149,14.434968 L15.5495868,17.6801706 L15.5495868,16.6183369 L18.6942149,13.3731343 L18.6942149,14.434968 Z M18.6942149,12.3113006 L15.5495868,15.5565032 L15.5495868,14.4946695 L18.6942149,11.249467 L18.6942149,12.3113006 Z'
                      id='Shape'
                    ></path>
                    <path
                      d='M12.2190083,0.0341151386 L7.77272727,0.0341151386 C7.41322314,0.0341151386 7.12396694,0.332622601 7.12396694,0.703624733 L7.12396694,19.3304904 C7.12396694,19.7014925 7.41322314,20 7.77272727,20 L12.214876,20 C12.5743802,20 12.8636801,19.7014925 12.8636801,19.3304904 L12.8636801,0.703624733 C12.8677686,0.332622601 12.5785124,0.0341151386 12.2190083,0.0341151386 Z'
                      id='Path'
                    ></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      );

    case 'tickets':
      return (
        <svg
          className={props.className}
          width='18'
          height='16'
          viewBox='0 0 18 16'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M17.9829 6.64025L15.9085 0.256651C15.8484 0.0720455 15.6502 -0.0289936 15.4654 0.0309478L0.242996 4.97764C0.058355 5.03765 -0.042684 5.23601 0.0172925 5.42068L0.999207 8.44233L0.998838 8.44844C0.998583 8.45228 0.998328 8.45611 0.998328 8.46001V15.1722C0.998328 15.3664 1.15576 15.5238 1.34989 15.5238H17.3559C17.5501 15.5238 17.7075 15.3664 17.7075 15.1722V8.46001C17.7075 8.26588 17.5501 8.10845 17.3559 8.10845H14.6025L17.7572 7.08329C17.9418 7.02328 18.0429 6.82493 17.9829 6.64025ZM17.0043 8.81157V14.8207H1.70142V8.81157H3.64879V12.7283C3.64879 12.9224 3.80622 13.0798 4.00036 13.0798C4.19449 13.0798 4.35192 12.9224 4.35192 12.7283V8.81157H12.383H17.0043ZM1.63002 8.10845H12.3274L17.2055 6.52322L15.3484 0.808288L3.31646 4.71819L4.02447 6.86996C4.08519 7.05443 3.98485 7.2531 3.80042 7.31381C3.76393 7.32583 3.72687 7.33153 3.69045 7.33153C3.54276 7.33153 3.40527 7.2377 3.35657 7.08976L2.64775 4.93553L0.794632 5.53772L1.63002 8.10845Z'
            fill='#6071B5'
          />
          <path
            d='M14.8151 2.35039C14.7551 2.16578 14.5568 2.06478 14.3721 2.12468L5.20589 5.10337C5.02125 5.16338 4.92021 5.36173 4.98018 5.54641C5.02849 5.69498 5.16627 5.78941 5.31448 5.78941C5.35048 5.78941 5.38712 5.78382 5.42322 5.77211L14.5894 2.79343C14.7741 2.73341 14.8752 2.53506 14.8151 2.35039Z'
            fill='#6071B5'
          />
          <path
            d='M13.2689 4.63459L15.004 4.07079C15.1886 4.01078 15.2896 3.81242 15.2297 3.62775C15.1696 3.44311 14.9713 3.3421 14.7866 3.40204L13.0516 3.96585C12.8669 4.02586 12.7659 4.22421 12.8259 4.40888C12.8742 4.55745 13.012 4.65188 13.1602 4.65188C13.1962 4.65188 13.2329 4.64629 13.2689 4.63459Z'
            fill='#6071B5'
          />
          <path
            d='M14.7361 6.24812C14.7844 6.39669 14.9221 6.49112 15.0704 6.49112C15.1063 6.49112 15.143 6.48553 15.1791 6.47383L15.7281 6.29541C15.9128 6.2354 16.0138 6.03705 15.9538 5.85237C15.8938 5.66773 15.6955 5.56669 15.5108 5.62667L14.9618 5.80509C14.7771 5.8651 14.676 6.06345 14.7361 6.24812Z'
            fill='#6071B5'
          />
          <path
            d='M13.7354 6.20478L13.1864 6.3832C13.0017 6.44321 12.9007 6.64156 12.9607 6.82624C13.0089 6.97481 13.1467 7.06924 13.295 7.06924C13.3309 7.06924 13.3676 7.06365 13.4037 7.05194L13.9528 6.87352C14.1374 6.81351 14.2385 6.61516 14.1785 6.43048C14.1185 6.24584 13.9203 6.14484 13.7354 6.20478Z'
            fill='#6071B5'
          />
          <path
            d='M8.82815 5.33759L5.61996 6.38012C5.43532 6.44013 5.33425 6.63848 5.39426 6.82315C5.44256 6.97172 5.58034 7.06615 5.72856 7.06615C5.76452 7.06615 5.80119 7.06056 5.8373 7.04886L9.04548 6.00633C9.23012 5.94632 9.33116 5.74797 9.27118 5.56329C9.2111 5.37865 9.01279 5.27765 8.82815 5.33759Z'
            fill='#6071B5'
          />
          <path
            d='M4 13.5488C3.80587 13.5488 3.64844 13.7063 3.64844 13.9004V14.0381C3.64844 14.2322 3.80587 14.3896 4 14.3896C4.19413 14.3896 4.35156 14.2322 4.35156 14.0381V13.9004C4.35156 13.7063 4.19413 13.5488 4 13.5488Z'
            fill='#6071B5'
          />
          <path
            d='M5.67969 10.1133C5.67969 10.3074 5.83712 10.4648 6.03125 10.4648H15.6693C15.8634 10.4648 16.0208 10.3074 16.0208 10.1133C16.0208 9.91915 15.8634 9.76172 15.6693 9.76172H6.03125C5.83712 9.76172 5.67969 9.91911 5.67969 10.1133Z'
            fill='#6071B5'
          />
          <path
            d='M15.6701 11.1035H13.8457C13.6516 11.1035 13.4941 11.2609 13.4941 11.4551C13.4941 11.6492 13.6516 11.8066 13.8457 11.8066H15.6701C15.8642 11.8066 16.0216 11.6492 16.0216 11.4551C16.0216 11.2609 15.8642 11.1035 15.6701 11.1035Z'
            fill='#6071B5'
          />
          <path
            d='M15.6691 13.4453H15.0918C14.8977 13.4453 14.7402 13.6027 14.7402 13.7969C14.7402 13.991 14.8977 14.1484 15.0918 14.1484H15.6691C15.8633 14.1484 16.0207 13.991 16.0207 13.7969C16.0207 13.6027 15.8633 13.4453 15.6691 13.4453Z'
            fill='#6071B5'
          />
          <path
            d='M13.8019 13.4453H13.2246C13.0305 13.4453 12.873 13.6027 12.873 13.7969C12.873 13.991 13.0305 14.1484 13.2246 14.1484H13.8019C13.996 14.1484 14.1535 13.991 14.1535 13.7969C14.1535 13.6027 13.9961 13.4453 13.8019 13.4453Z'
            fill='#6071B5'
          />
          <path
            d='M9.40456 11.1035H6.03125C5.83712 11.1035 5.67969 11.2609 5.67969 11.4551C5.67969 11.6492 5.83712 11.8066 6.03125 11.8066H9.40456C9.5987 11.8066 9.75612 11.6492 9.75612 11.4551C9.75612 11.2609 9.5987 11.1035 9.40456 11.1035Z'
            fill='#6071B5'
          />
        </svg>
      );

    case 'send-email':
      return (
        <svg
          className={props.className}
          xmlns='http://www.w3.org/2000/svg'
          width='20'
          height='20'
        >
          <g fill={!!color ? color : '#6071B5'}>
            <path d='M18.14 15.754H5.978a1.73 1.73 0 0 1-1.727-1.73v-2.231a.328.328 0 1 1 .656 0v2.23c0 .59.48 1.07 1.07 1.07h12.165c.59 0 1.07-.48 1.07-1.07v-8.07c0-.59-.48-1.07-1.07-1.07H5.977c-.59 0-1.07.48-1.07 1.07v2.203a.325.325 0 0 1-.329.328.325.325 0 0 1-.328-.328V5.953c0-.953.773-1.73 1.727-1.73H18.14a1.73 1.73 0 0 1 1.726 1.73v8.07a1.73 1.73 0 0 1-1.726 1.73Zm0 0' />
            <path d='m14.102 9.988 3.671-3.367a.332.332 0 0 0 .02-.465.325.325 0 0 0-.465-.02l-5.27 4.833L6.79 6.137a.325.325 0 0 0-.465.02.328.328 0 0 0 .02.464l3.672 3.367-3.672 3.371a.328.328 0 0 0 .222.57c.079 0 .16-.027.223-.085l3.715-3.41 1.332 1.226c.062.055.14.086.223.086.078 0 .16-.031.222-.086l1.332-1.226 3.715 3.41a.329.329 0 1 0 .445-.484ZM5.691 10.316H1.766a.325.325 0 0 1-.329-.328c0-.18.145-.328.329-.328H5.69a.328.328 0 1 1 0 .656ZM2.852 8.016H.438a.328.328 0 1 1 0-.657h2.414a.328.328 0 1 1 0 .657ZM2.852 12.621H1.074a.328.328 0 0 1-.328-.332c0-.18.145-.328.328-.328h1.781a.33.33 0 0 1-.003.66Zm0 0' />
          </g>
        </svg>
      );

    case 'confirm':
      return (
        <svg
          className={props.className}
          width='36px'
          height='36px'
          viewBox='0 0 36 36'
          version='1.1'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g
            id='Assets'
            stroke='none'
            stroke-width='1'
            fill='none'
            fill-rule='evenodd'
          >
            <g transform='translate(-195.000000, -592.000000)' id='ic_tick'>
              <g transform='translate(195.000000, 592.000000)'>
                <circle
                  id='Oval'
                  fill='#6071B5'
                  cx='18'
                  cy='18'
                  r='18'
                ></circle>
                <polyline
                  id='Tick'
                  stroke='#FFFFFF'
                  stroke-width='1.5'
                  stroke-linecap='round'
                  stroke-linejoin='round'
                  points='12 17.195011 16.5029221 22 24 14'
                ></polyline>
              </g>
            </g>
          </g>
        </svg>
      );

    case 'map-pin-solid':
      return (
        <svg
          className={props.className}
          xmlns='http://www.w3.org/2000/svg'
          width='18'
          height='18'
          viewBox='0 0 18 18'
          fill='none'
        >
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M8.655 16.7633L8.7075 16.7933L8.7285 16.8053C8.81177 16.8503 8.90495 16.8739 8.99963 16.8739C9.0943 16.8739 9.18748 16.8503 9.27075 16.8053L9.29175 16.794L9.345 16.7633C9.63834 16.5893 9.92457 16.4037 10.203 16.2067C10.9238 15.6979 11.5973 15.125 12.2153 14.4952C13.6733 13.0027 15.1875 10.7603 15.1875 7.875C15.1875 6.23397 14.5356 4.66016 13.3752 3.49978C12.2148 2.3394 10.641 1.6875 9 1.6875C7.35897 1.6875 5.78516 2.3394 4.62478 3.49978C3.4644 4.66016 2.8125 6.23397 2.8125 7.875C2.8125 10.7595 4.3275 13.0027 5.78475 14.4952C6.40248 15.125 7.07571 15.6978 7.79625 16.2067C8.07493 16.4037 8.36141 16.5893 8.655 16.7633ZM9 10.125C9.59674 10.125 10.169 9.88795 10.591 9.46599C11.0129 9.04403 11.25 8.47174 11.25 7.875C11.25 7.27826 11.0129 6.70597 10.591 6.28401C10.169 5.86205 9.59674 5.625 9 5.625C8.40326 5.625 7.83097 5.86205 7.40901 6.28401C6.98705 6.70597 6.75 7.27826 6.75 7.875C6.75 8.47174 6.98705 9.04403 7.40901 9.46599C7.83097 9.88795 8.40326 10.125 9 10.125Z'
            fill='white'
          />
        </svg>
      );
    case 'calendar':
      return (
        <svg
          className={props.className}
          xmlns='http://www.w3.org/2000/svg'
          width='20'
          height='20'
          viewBox='0 0 20 20'
          fill='none'
        >
          <path
            d='M6.45826 2.08203C6.45826 1.91627 6.39241 1.7573 6.2752 1.64009C6.15799 1.52288 5.99902 1.45703 5.83326 1.45703C5.6675 1.45703 5.50852 1.52288 5.39131 1.64009C5.2741 1.7573 5.20826 1.91627 5.20826 2.08203V3.3987C4.00826 3.49453 3.22159 3.72953 2.64326 4.3087C2.06409 4.88703 1.82909 5.67453 1.73242 6.8737H18.2674C18.1708 5.6737 17.9358 4.88703 17.3566 4.3087C16.7783 3.72953 15.9908 3.49453 14.7916 3.39786V2.08203C14.7916 1.91627 14.7257 1.7573 14.6085 1.64009C14.4913 1.52288 14.3323 1.45703 14.1666 1.45703C14.0008 1.45703 13.8419 1.52288 13.7246 1.64009C13.6074 1.7573 13.5416 1.91627 13.5416 2.08203V3.34286C12.9874 3.33203 12.3658 3.33203 11.6666 3.33203H8.33326C7.63409 3.33203 7.01242 3.33203 6.45826 3.34286V2.08203Z'
            fill='#6071B5'
          />
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M1.66602 10C1.66602 9.30083 1.66602 8.67917 1.67685 8.125H18.3218C18.3327 8.67917 18.3327 9.30083 18.3327 10V11.6667C18.3327 14.8092 18.3327 16.3808 17.356 17.3567C16.3802 18.3333 14.8085 18.3333 11.666 18.3333H8.33268C5.19018 18.3333 3.61852 18.3333 2.64268 17.3567C1.66602 16.3808 1.66602 14.8092 1.66602 11.6667V10ZM14.166 11.6667C14.387 11.6667 14.599 11.5789 14.7553 11.4226C14.9116 11.2663 14.9993 11.0543 14.9993 10.8333C14.9993 10.6123 14.9116 10.4004 14.7553 10.2441C14.599 10.0878 14.387 10 14.166 10C13.945 10 13.733 10.0878 13.5768 10.2441C13.4205 10.4004 13.3327 10.6123 13.3327 10.8333C13.3327 11.0543 13.4205 11.2663 13.5768 11.4226C13.733 11.5789 13.945 11.6667 14.166 11.6667ZM14.166 15C14.387 15 14.599 14.9122 14.7553 14.7559C14.9116 14.5996 14.9993 14.3877 14.9993 14.1667C14.9993 13.9457 14.9116 13.7337 14.7553 13.5774C14.599 13.4211 14.387 13.3333 14.166 13.3333C13.945 13.3333 13.733 13.4211 13.5768 13.5774C13.4205 13.7337 13.3327 13.9457 13.3327 14.1667C13.3327 14.3877 13.4205 14.5996 13.5768 14.7559C13.733 14.9122 13.945 15 14.166 15ZM10.8327 10.8333C10.8327 11.0543 10.7449 11.2663 10.5886 11.4226C10.4323 11.5789 10.2204 11.6667 9.99935 11.6667C9.77833 11.6667 9.56637 11.5789 9.41009 11.4226C9.25381 11.2663 9.16602 11.0543 9.16602 10.8333C9.16602 10.6123 9.25381 10.4004 9.41009 10.2441C9.56637 10.0878 9.77833 10 9.99935 10C10.2204 10 10.4323 10.0878 10.5886 10.2441C10.7449 10.4004 10.8327 10.6123 10.8327 10.8333ZM10.8327 14.1667C10.8327 14.3877 10.7449 14.5996 10.5886 14.7559C10.4323 14.9122 10.2204 15 9.99935 15C9.77833 15 9.56637 14.9122 9.41009 14.7559C9.25381 14.5996 9.16602 14.3877 9.16602 14.1667C9.16602 13.9457 9.25381 13.7337 9.41009 13.5774C9.56637 13.4211 9.77833 13.3333 9.99935 13.3333C10.2204 13.3333 10.4323 13.4211 10.5886 13.5774C10.7449 13.7337 10.8327 13.9457 10.8327 14.1667ZM5.83268 11.6667C6.0537 11.6667 6.26566 11.5789 6.42194 11.4226C6.57822 11.2663 6.66602 11.0543 6.66602 10.8333C6.66602 10.6123 6.57822 10.4004 6.42194 10.2441C6.26566 10.0878 6.0537 10 5.83268 10C5.61167 10 5.39971 10.0878 5.24343 10.2441C5.08715 10.4004 4.99935 10.6123 4.99935 10.8333C4.99935 11.0543 5.08715 11.2663 5.24343 11.4226C5.39971 11.5789 5.61167 11.6667 5.83268 11.6667ZM5.83268 15C6.0537 15 6.26566 14.9122 6.42194 14.7559C6.57822 14.5996 6.66602 14.3877 6.66602 14.1667C6.66602 13.9457 6.57822 13.7337 6.42194 13.5774C6.26566 13.4211 6.0537 13.3333 5.83268 13.3333C5.61167 13.3333 5.39971 13.4211 5.24343 13.5774C5.08715 13.7337 4.99935 13.9457 4.99935 14.1667C4.99935 14.3877 5.08715 14.5996 5.24343 14.7559C5.39971 14.9122 5.61167 15 5.83268 15Z'
            fill='#6071B5'
          />
        </svg>
      );
    case 'cake':
      return (
        <svg
          className={props.className}
          xmlns='http://www.w3.org/2000/svg'
          width='20'
          height='20'
          viewBox='0 0 20 20'
          fill='none'
        >
          <path
            d='M3.33334 18.3346C3.09723 18.3346 2.89917 18.2546 2.73917 18.0946C2.57917 17.9346 2.49945 17.7369 2.5 17.5013V14.168C2.5 13.7096 2.66334 13.3171 2.99 12.9905C3.31667 12.6638 3.70889 12.5007 4.16667 12.5013H15.8333C16.2917 12.5013 16.6842 12.6646 17.0108 12.9913C17.3375 13.318 17.5006 13.7102 17.5 14.168V17.5013C17.5 17.7374 17.42 17.9355 17.26 18.0955C17.1 18.2555 16.9022 18.3352 16.6667 18.3346H3.33334ZM4.16667 10.8346V8.33464C4.16667 7.8763 4.33 7.4838 4.65667 7.15714C4.98334 6.83047 5.37556 6.66741 5.83334 6.66797H9.16667V5.45964C8.91667 5.29297 8.71528 5.09158 8.5625 4.85547C8.40972 4.61936 8.33334 4.33464 8.33334 4.0013C8.33334 3.79297 8.375 3.58797 8.45834 3.3863C8.54167 3.18464 8.66667 3.00075 8.83334 2.83464L10 1.66797L11.1667 2.83464C11.3333 3.0013 11.4583 3.18519 11.5417 3.3863C11.625 3.58741 11.6667 3.79241 11.6667 4.0013C11.6667 4.33464 11.5903 4.61936 11.4375 4.85547C11.2847 5.09158 11.0833 5.29297 10.8333 5.45964V6.66797H14.1667C14.625 6.66797 15.0175 6.83102 15.3442 7.15714C15.6708 7.48325 15.8339 7.87575 15.8333 8.33464V10.8346H4.16667Z'
            fill='#6071B5'
          />
        </svg>
      );
    case 'map-pin-fill':
      return (
        <svg
          className={props.className}
          xmlns='http://www.w3.org/2000/svg'
          width='20'
          height='20'
          viewBox='0 0 20 20'
          fill='none'
        >
          <path
            d='M10 1.25C8.17727 1.25207 6.42979 1.97706 5.14092 3.26592C3.85206 4.55479 3.12707 6.30227 3.125 8.125C3.125 14.0078 9.375 18.4508 9.64141 18.6367C9.74649 18.7103 9.87169 18.7498 10 18.7498C10.1283 18.7498 10.2535 18.7103 10.3586 18.6367C10.625 18.4508 16.875 14.0078 16.875 8.125C16.8729 6.30227 16.1479 4.55479 14.8591 3.26592C13.5702 1.97706 11.8227 1.25207 10 1.25ZM10 5.625C10.4945 5.625 10.9778 5.77162 11.3889 6.04633C11.8 6.32103 12.1205 6.71148 12.3097 7.16829C12.4989 7.62511 12.5484 8.12777 12.452 8.61273C12.3555 9.09768 12.1174 9.54314 11.7678 9.89277C11.4181 10.2424 10.9727 10.4805 10.4877 10.577C10.0028 10.6734 9.50011 10.6239 9.04329 10.4347C8.58648 10.2455 8.19603 9.92505 7.92133 9.51393C7.64662 9.1028 7.5 8.61945 7.5 8.125C7.5 7.46196 7.76339 6.82607 8.23223 6.35723C8.70107 5.88839 9.33696 5.625 10 5.625Z'
            fill='#6071B5'
          />
        </svg>
      );
    case 'total-tickets-sold':
      return (
        <svg
          className={props.className}
          xmlns='http://www.w3.org/2000/svg'
          width='25'
          height='25'
          viewBox='0 0 25 25'
          fill='none'
        >
          <path
            d='M17.5237 5.46C17.5237 5.47 17.5237 5.47 17.5237 5.48C17.2737 5.47 17.0237 5.46 16.7537 5.46H9.05371L10.1237 4.4C11.1037 3.41 12.1837 2.5 13.4337 2.5C14.6937 2.5 15.7737 3.41 16.7537 4.4L17.3137 4.96C17.4537 5.09 17.5237 5.27 17.5237 5.46Z'
            fill='white'
          />
          <path
            d='M21.1735 13.67C21.5635 13.67 21.8735 13.35 21.8735 12.95V12.07C21.8735 8.13995 20.6735 6.94995 16.7535 6.94995H10.4535H7.91346C3.99346 6.94995 2.79346 8.14995 2.79346 12.07V12.5C2.79346 12.9 3.10346 13.21 3.49346 13.21C4.33346 13.21 5.00346 13.89 5.00346 14.72C5.00346 15.55 4.33346 16.24 3.49346 16.24C3.10346 16.24 2.79346 16.55 2.79346 16.95V17.38C2.79346 21.31 3.99346 22.5 7.91346 22.5H10.4435H16.7435C20.6635 22.5 21.8635 21.3 21.8635 17.38C21.8635 16.99 21.5535 16.67 21.1635 16.67C20.3235 16.67 19.6535 16 19.6535 15.17C19.6635 14.34 20.3335 13.67 21.1735 13.67ZM11.1535 19.36C11.1535 19.75 10.8335 20.07 10.4435 20.07C10.0535 20.07 9.73346 19.75 9.73346 19.36V16.68C9.73346 16.29 10.0535 15.97 10.4435 15.97C10.8335 15.97 11.1535 16.29 11.1535 16.68V19.36ZM11.1535 12.77C11.1535 13.16 10.8335 13.48 10.4435 13.48C10.0535 13.48 9.73346 13.16 9.73346 12.77V10.09C9.73346 9.69995 10.0535 9.37995 10.4435 9.37995C10.8335 9.37995 11.1535 9.69995 11.1535 10.09V12.77Z'
            fill='white'
          />
        </svg>
      );
    case 'unique-buyers':
      return (
        <svg
          className={props.className}
          xmlns='http://www.w3.org/2000/svg'
          width='25'
          height='25'
          viewBox='0 0 25 25'
          fill='none'
        >
          <path
            d='M12.6667 2C9.9157 2 7.6792 4.2365 7.6792 6.9875C7.6792 9.686 9.7897 11.87 12.5407 11.9645C12.6247 11.954 12.7087 11.954 12.7717 11.9645C12.7927 11.9645 12.8032 11.9645 12.8242 11.9645C12.8347 11.9645 12.8347 11.9645 12.8452 11.9645C15.5332 11.87 17.6437 9.686 17.6542 6.9875C17.6542 4.2365 15.4177 2 12.6667 2Z'
            fill='white'
          />
          <path
            d='M18.0007 14.7676C15.0712 12.8146 10.2937 12.8146 7.34316 14.7676C6.00966 15.6496 5.27466 16.8571 5.27466 18.1486C5.27466 19.4401 6.00966 20.6371 7.33266 21.5191C8.80266 22.5061 10.7347 22.9996 12.6667 22.9996C14.5987 22.9996 16.5307 22.5061 18.0007 21.5191C19.3237 20.6266 20.0587 19.4296 20.0587 18.1276C20.0482 16.8466 19.3237 15.6391 18.0007 14.7676ZM15.1132 17.2876L12.4672 19.9336C12.3412 20.0596 12.1732 20.1226 12.0052 20.1226C11.8372 20.1226 11.6692 20.0491 11.5432 19.9336L10.2202 18.6106C9.96816 18.3586 9.96816 17.9386 10.2202 17.6866C10.4722 17.4346 10.8922 17.4346 11.1442 17.6866L12.0052 18.5476L14.1892 16.3636C14.4412 16.1116 14.8612 16.1116 15.1132 16.3636C15.3757 16.6156 15.3757 17.0356 15.1132 17.2876Z'
            fill='white'
          />
        </svg>
      );
    case 'unidentified-customers':
      return (
        <svg
          className={props.className}
          xmlns='http://www.w3.org/2000/svg'
          width='24'
          height='25'
          viewBox='0 0 24 25'
          fill='none'
        >
          <g clipPath='url(#clip0_1571_7590)'>
            <path
              d='M10.4248 1.91399C10.8856 1.65986 11.4001 1.51857 11.9261 1.50171C12.4521 1.48485 12.9746 1.59289 13.4508 1.81699L13.6408 1.91399L20.4158 5.90899L20.5118 5.97199L20.6038 6.04899L20.7108 6.12399C21.0583 6.38459 21.3496 6.71274 21.5671 7.08873C21.7847 7.46472 21.924 7.8808 21.9768 8.31199L21.9948 8.51399L21.9998 8.71799V16.002C21.9998 17.108 21.4298 18.131 20.5458 18.695L20.3758 18.795L13.5728 23.097C12.6548 23.601 11.5538 23.632 10.5688 23.165L10.3728 23.065L3.67776 18.828C3.20124 18.5674 2.79823 18.1908 2.50611 17.733C2.214 17.2751 2.04223 16.7509 2.00676 16.209L1.99976 16.002V8.71699C1.99976 7.61099 2.56976 6.58899 3.47576 6.01199L10.4248 1.91399ZM11.9998 15.5C11.7548 15.5 11.5184 15.5899 11.3354 15.7527C11.1523 15.9155 11.0354 16.1397 11.0068 16.383L10.9998 16.5L11.0068 16.627C11.0357 16.87 11.1527 17.094 11.3357 17.2566C11.5187 17.4191 11.755 17.5089 11.9998 17.5089C12.2445 17.5089 12.4808 17.4191 12.6638 17.2566C12.8468 17.094 12.9638 16.87 12.9928 16.627L12.9998 16.51L12.9928 16.383C12.9641 16.1397 12.8472 15.9155 12.6641 15.7527C12.4811 15.5899 12.2447 15.5 11.9998 15.5ZM13.3678 8.82698C12.7691 8.52095 12.0846 8.42633 11.4254 8.5585C10.7663 8.69066 10.1711 9.04184 9.73676 9.55499C9.57114 9.74899 9.48592 9.99895 9.49853 10.2537C9.51115 10.5085 9.62065 10.7488 9.80462 10.9255C9.9886 11.1022 10.2331 11.2019 10.4882 11.2042C10.7433 11.2065 10.9896 11.1113 11.1768 10.938L11.3478 10.758C11.4953 10.6226 11.6808 10.5356 11.8792 10.5088C12.0777 10.482 12.2796 10.5166 12.4578 10.608C12.6498 10.7052 12.8054 10.8618 12.9014 11.0545C12.9973 11.2472 13.0285 11.4658 12.9903 11.6776C12.9521 11.8895 12.8466 12.0834 12.6894 12.2305C12.5322 12.3776 12.3317 12.47 12.1178 12.494L11.8858 12.506C11.6314 12.534 11.3975 12.6584 11.2321 12.8536C11.0667 13.0489 10.9824 13.3001 10.9967 13.5556C11.0109 13.811 11.1225 14.0514 11.3085 14.227C11.4946 14.4027 11.7409 14.5004 11.9968 14.5C12.6714 14.502 13.327 14.2766 13.8577 13.8601C14.3885 13.4437 14.7633 12.8605 14.9218 12.2047C15.0803 11.549 15.0131 10.8589 14.7311 10.2461C14.4492 9.6332 13.9689 9.13326 13.3678 8.82698Z'
              fill='white'
            />
          </g>
          <defs>
            <clipPath id='clip0_1571_7590'>
              <rect
                width='24'
                height='24'
                fill='white'
                transform='translate(-0.000244141 0.5)'
              />
            </clipPath>
          </defs>
        </svg>
      );
    case 'male':
      return (
        <svg
          className={props.className}
          xmlns='http://www.w3.org/2000/svg'
          width='25'
          height='25'
          viewBox='0 0 25 25'
          fill='none'
        >
          <g clipPath='url(#clip0_1571_7599)'>
            <path
              d='M3.28906 15.0843C3.28906 16.7977 3.9697 18.4409 5.18124 19.6525C6.39279 20.864 8.03599 21.5446 9.74937 21.5446C11.4628 21.5446 13.106 20.864 14.3175 19.6525C15.529 18.4409 16.2097 16.7977 16.2097 15.0843C16.2097 13.371 15.529 11.7277 14.3175 10.5162C13.106 9.30466 11.4628 8.62402 9.74937 8.62402C8.03599 8.62402 6.39279 9.30466 5.18124 10.5162C3.9697 11.7277 3.28906 13.371 3.28906 15.0843Z'
              stroke='white'
              stroke-width='2.3'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
            <path
              d='M21.378 3.45605L14.4009 10.4332'
              stroke='white'
              stroke-width='2.3'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
            <path
              d='M21.3778 3.45605H14.9175'
              stroke='white'
              stroke-width='2.35947'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
            <path
              d='M21.3779 3.45605V9.91636'
              stroke='white'
              stroke-width='2.3'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
          </g>
          <defs>
            <clipPath id='clip0_1571_7599'>
              <rect
                width='24'
                height='24'
                fill='white'
                transform='translate(0.333496 0.5)'
              />
            </clipPath>
          </defs>
        </svg>
      );
    case 'female':
      return (
        <svg
          className={props.className}
          xmlns='http://www.w3.org/2000/svg'
          width='25'
          height='25'
          viewBox='0 0 25 25'
          fill='none'
        >
          <g clipPath='url(#clip0_1571_7610)'>
            <path
              d='M6.51978 8.38028C6.51978 10.0105 7.16739 11.574 8.32016 12.7268C9.47292 13.8796 11.0364 14.5272 12.6667 14.5272C14.2969 14.5272 15.8604 13.8796 17.0132 12.7268C18.1659 11.574 18.8135 10.0105 18.8135 8.38028C18.8135 6.75003 18.1659 5.18654 17.0132 4.03378C15.8604 2.88101 14.2969 2.2334 12.6667 2.2334C11.0364 2.2334 9.47292 2.88101 8.32016 4.03378C7.16739 5.18654 6.51978 6.75003 6.51978 8.38028Z'
              stroke='white'
              stroke-width='2.3'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
            <path
              d='M12.6667 14.5272V23.1329'
              stroke='white'
              stroke-width='2.3'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
            <path
              d='M8.97876 19.4443H16.355'
              stroke='white'
              stroke-width='2.3'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
          </g>
          <defs>
            <clipPath id='clip0_1571_7610'>
              <rect
                width='24'
                height='24'
                fill='white'
                transform='translate(0.666748 0.5)'
              />
            </clipPath>
          </defs>
        </svg>
      );
    case 'average-age':
      return (
        <svg
          className={props.className}
          xmlns='http://www.w3.org/2000/svg'
          width='24'
          height='25'
          viewBox='0 0 24 25'
          fill='none'
        >
          <path
            d='M3.99976 22.5C3.71643 22.5 3.47876 22.404 3.28676 22.212C3.09476 22.02 2.99909 21.7827 2.99976 21.5V17.5C2.99976 16.95 3.19576 16.479 3.58776 16.087C3.97976 15.695 4.45043 15.4993 4.99976 15.5H18.9998C19.5498 15.5 20.0208 15.696 20.4128 16.088C20.8048 16.48 21.0004 16.9507 20.9998 17.5V21.5C20.9998 21.7833 20.9038 22.021 20.7118 22.213C20.5198 22.405 20.2824 22.5007 19.9998 22.5H3.99976ZM4.99976 13.5V10.5C4.99976 9.95 5.19576 9.479 5.58776 9.087C5.97976 8.695 6.45043 8.49933 6.99976 8.5H10.9998V7.05C10.6998 6.85 10.4581 6.60833 10.2748 6.325C10.0914 6.04167 9.99976 5.7 9.99976 5.3C9.99976 5.05 10.0498 4.804 10.1498 4.562C10.2498 4.32 10.3998 4.09933 10.5998 3.9L11.9998 2.5L13.3998 3.9C13.5998 4.1 13.7498 4.32067 13.8498 4.562C13.9498 4.80333 13.9998 5.04933 13.9998 5.3C13.9998 5.7 13.9081 6.04167 13.7248 6.325C13.5414 6.60833 13.2998 6.85 12.9998 7.05V8.5H16.9998C17.5498 8.5 18.0208 8.69567 18.4128 9.087C18.8048 9.47833 19.0004 9.94933 18.9998 10.5V13.5H4.99976Z'
            fill='white'
          />
        </svg>
      );
    case 'dashboard-stats':
      return (
        <svg
          className={props.className}
          width='24'
          height='24'
          viewBox='0 0 24 24'
          fill='currentColor'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M11.5139 4.21064C11.5924 4.11012 11.6999 4.03672 11.8213 4H11.3835V4.5752C11.3867 4.44309 11.4323 4.3152 11.5139 4.21064Z'
            fill='currentColor'
          />
          <path
            d='M12.5707 4.34891C12.5985 4.41654 12.614 4.48846 12.6166 4.5613V4H12.2005C12.2835 4.02847 12.3594 4.07432 12.4233 4.13449C12.4871 4.19466 12.5374 4.26776 12.5707 4.34891Z'
            fill='currentColor'
          />
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M11.3835 4.60506V5.22162H5.83452H3.98486V7.07127L3.98486 15.0864L3.98486 16.9361H5.83452H11.3835V17.1673L8.03067 18.8437C7.97189 18.8721 7.91854 18.9093 7.87218 18.9535C7.80169 19.0208 7.74737 19.1043 7.71469 19.198C7.66052 19.3534 7.67028 19.5239 7.74182 19.672C7.81336 19.8202 7.94082 19.9339 8.09616 19.988C8.25151 20.0422 8.42201 20.0324 8.57016 19.9609L11.3835 18.5545V18.7857C11.3835 18.9493 11.4484 19.1061 11.5641 19.2217C11.6797 19.3373 11.8365 19.4023 12 19.4023C12.1636 19.4023 12.3204 19.3373 12.436 19.2217C12.5516 19.1061 12.6166 18.9493 12.6166 18.7857V18.5545L15.4299 19.9609C15.5781 20.0324 15.7486 20.0422 15.9039 19.988C16.0592 19.9339 16.1867 19.8202 16.2582 19.672C16.3298 19.5239 16.3395 19.3534 16.2854 19.198C16.2312 19.0427 16.1175 18.9152 15.9694 18.8437L12.6166 17.1673V16.9361H18.1655H20.0152V15.0864V7.07127V5.22162H18.1655H12.6166V4.60506V4.5613C12.614 4.48846 12.5985 4.41654 12.5707 4.34891C12.5374 4.26776 12.4871 4.19466 12.4233 4.13449C12.3594 4.07432 12.2835 4.02847 12.2005 4H11.8213C11.6999 4.03672 11.5924 4.11012 11.5139 4.21064C11.4323 4.3152 11.3867 4.44309 11.3835 4.5752V4.60506ZM18.7821 6.45472H5.21797V15.703H18.7821V6.45472Z'
            fill='currentColor'
          />
          <path
            d='M11.5641 19.2217C11.4484 19.1061 11.3835 18.9493 11.3835 18.7857V19.4505H12.6166V18.7857C12.6166 18.9493 12.5516 19.1061 12.436 19.2217C12.3204 19.3373 12.1636 19.4023 12 19.4023C11.8365 19.4023 11.6797 19.3373 11.5641 19.2217Z'
            fill='currentColor'
          />
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M5.21797 6.45472H18.7821V15.703H5.21797V6.45472ZM16.4891 7.86107C16.5882 7.76372 16.7173 7.70267 16.8554 7.68782C16.9863 7.66584 17.1208 7.68668 17.2389 7.74724C17.357 7.80781 17.4524 7.90487 17.5109 8.02399C17.5694 8.14312 17.5879 8.27795 17.5637 8.40844C17.5395 8.53894 17.4738 8.65812 17.3764 8.74829L14.9102 11.2145C14.8527 11.274 14.7838 11.3213 14.7076 11.3536C14.6315 11.3859 14.5496 11.4025 14.4669 11.4025C14.3841 11.4025 14.3022 11.3859 14.2261 11.3536C14.1499 11.3213 14.0811 11.274 14.0236 11.2145L12.7522 9.94255L10.6905 13.5457C10.6339 13.649 10.5489 13.734 10.4455 13.7906C10.3422 13.8471 10.2248 13.8728 10.1072 13.8647C9.98967 13.8566 9.87691 13.815 9.78228 13.7448C9.68766 13.6746 9.61513 13.5788 9.57329 13.4686L8.68669 11.2725L7.51154 12.4476C7.45324 12.5059 7.38404 12.5521 7.30789 12.5836C7.23174 12.6151 7.15013 12.6313 7.06771 12.6313C6.9853 12.6312 6.9037 12.615 6.82757 12.5834C6.75144 12.5518 6.68227 12.5056 6.62401 12.4473C6.56576 12.389 6.51955 12.3198 6.48804 12.2436C6.45653 12.1675 6.44033 12.0859 6.44035 12.0035C6.44038 11.9211 6.45664 11.8394 6.48821 11.7633C6.51977 11.6872 6.56602 11.618 6.62432 11.5598L8.47398 9.71011C8.54629 9.63521 8.63639 9.57983 8.73588 9.54915C8.83537 9.51848 8.94101 9.51349 9.04295 9.53467C9.14489 9.55584 9.23981 9.60249 9.31885 9.67025C9.39789 9.73802 9.45849 9.8247 9.49498 9.9222L10.2466 11.8107L12.0771 8.61203C12.1233 8.52732 12.1888 8.45464 12.2682 8.39984C12.3476 8.34504 12.4388 8.30965 12.5344 8.29651C12.63 8.28338 12.7274 8.29287 12.8186 8.32422C12.9099 8.35557 12.9925 8.4079 13.0599 8.47701L14.4662 9.8846L16.4891 7.86107Z'
            fill='currentColor'
          />
        </svg>
      );
    case 'stepper-done-step':
      return (
        <svg
          className={props.className}
          xmlns='http://www.w3.org/2000/svg'
          width='16'
          height='16'
          viewBox='0 0 16 16'
          fill='none'
        >
          <path
            d='M15.75 8C15.75 12.2802 12.2802 15.75 8 15.75C3.71978 15.75 0.25 12.2802 0.25 8C0.25 3.71978 3.71978 0.25 8 0.25C12.2802 0.25 15.75 3.71978 15.75 8ZM7.10356 12.1036L12.8536 6.35356C13.0488 6.15831 13.0488 5.84172 12.8536 5.64647L12.1465 4.93937C11.9512 4.74409 11.6346 4.74409 11.4393 4.93937L6.75 9.62869L4.56066 7.43934C4.36541 7.24409 4.04881 7.24409 3.85353 7.43934L3.14644 8.14644C2.95119 8.34169 2.95119 8.65828 3.14644 8.85353L6.39644 12.1035C6.59172 12.2988 6.90828 12.2988 7.10356 12.1036Z'
            fill={color}
          />
        </svg>
      );
    case 'stepper-current-step':
      return (
        <svg
          className={props.className}
          xmlns='http://www.w3.org/2000/svg'
          width='17'
          height='16'
          viewBox='0 0 17 16'
          fill='none'
        >
          <path
            d='M8.66602 0.25C4.3858 0.25 0.916016 3.71978 0.916016 8C0.916016 12.2802 4.3858 15.75 8.66602 15.75C12.9462 15.75 16.416 12.2802 16.416 8C16.416 3.71978 12.9462 0.25 8.66602 0.25ZM11.166 8C11.166 9.3785 10.0445 10.5 8.66602 10.5C7.28752 10.5 6.16602 9.3785 6.16602 8C6.16602 6.6215 7.28752 5.5 8.66602 5.5C10.0445 5.5 11.166 6.6215 11.166 8Z'
            fill={color}
          />
        </svg>
      );
    case 'transactions':
      return (
        <svg
          className={props.className}
          width='18'
          height='18'
          viewBox='0 0 18 18'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M7.12501 7.87407H9.00001C9.19892 7.87407 9.38968 7.79506 9.53034 7.6544C9.67099 7.51375 9.75001 7.32299 9.75001 7.12407C9.75001 6.92516 9.67099 6.7344 9.53034 6.59374C9.38968 6.45309 9.19892 6.37407 9.00001 6.37407H8.25001V5.99907C8.25001 5.80016 8.17099 5.6094 8.03034 5.46874C7.88968 5.32809 7.69892 5.24907 7.50001 5.24907C7.30109 5.24907 7.11033 5.32809 6.96968 5.46874C6.82902 5.6094 6.75001 5.80016 6.75001 5.99907V6.41157C6.29432 6.5041 5.88928 6.76265 5.6135 7.13702C5.33772 7.51139 5.21088 7.97488 5.25761 8.43751C5.30434 8.90014 5.52131 9.3289 5.86638 9.64056C6.21146 9.95222 6.66002 10.1245 7.12501 10.1241H7.87501C7.97446 10.1241 8.06984 10.1636 8.14017 10.2339C8.2105 10.3042 8.25001 10.3996 8.25001 10.4991C8.25001 10.5985 8.2105 10.6939 8.14017 10.7642C8.06984 10.8346 7.97446 10.8741 7.87501 10.8741H6.00001C5.80109 10.8741 5.61033 10.9531 5.46968 11.0937C5.32902 11.2344 5.25001 11.4252 5.25001 11.6241C5.25001 11.823 5.32902 12.0138 5.46968 12.1544C5.61033 12.2951 5.80109 12.3741 6.00001 12.3741H6.75001V12.7491C6.75001 12.948 6.82902 13.1388 6.96968 13.2794C7.11033 13.4201 7.30109 13.4991 7.50001 13.4991C7.69892 13.4991 7.88968 13.4201 8.03034 13.2794C8.17099 13.1388 8.25001 12.948 8.25001 12.7491V12.3366C8.70569 12.244 9.11073 11.9855 9.38651 11.6111C9.66229 11.2368 9.78913 10.7733 9.7424 10.3106C9.69567 9.84801 9.47871 9.41925 9.13363 9.10759C8.78856 8.79593 8.33999 8.62361 7.87501 8.62407H7.12501C7.02555 8.62407 6.93017 8.58457 6.85984 8.51424C6.78951 8.44391 6.75001 8.34853 6.75001 8.24907C6.75001 8.14962 6.78951 8.05424 6.85984 7.98391C6.93017 7.91358 7.02555 7.87407 7.12501 7.87407ZM15.75 8.99907H13.5V2.24907C13.5005 2.11692 13.4661 1.98697 13.4003 1.87238C13.3344 1.7578 13.2395 1.66265 13.125 1.59657C13.011 1.53075 12.8817 1.49609 12.75 1.49609C12.6184 1.49609 12.489 1.53075 12.375 1.59657L10.125 2.88657L7.87501 1.59657C7.76099 1.53075 7.63166 1.49609 7.50001 1.49609C7.36835 1.49609 7.23902 1.53075 7.12501 1.59657L4.87501 2.88657L2.62501 1.59657C2.51099 1.53075 2.38166 1.49609 2.25001 1.49609C2.11835 1.49609 1.98902 1.53075 1.87501 1.59657C1.76055 1.66265 1.66559 1.7578 1.59974 1.87238C1.53389 1.98697 1.49948 2.11692 1.50001 2.24907V14.2491C1.50001 14.8458 1.73706 15.4181 2.15902 15.8401C2.58097 16.262 3.15327 16.4991 3.75001 16.4991H14.25C14.8467 16.4991 15.419 16.262 15.841 15.8401C16.263 15.4181 16.5 14.8458 16.5 14.2491V9.74907C16.5 9.55016 16.421 9.3594 16.2803 9.21875C16.1397 9.07809 15.9489 8.99907 15.75 8.99907ZM3.75001 14.9991C3.55109 14.9991 3.36033 14.9201 3.21968 14.7794C3.07902 14.6388 3.00001 14.448 3.00001 14.2491V3.54657L4.50001 4.40157C4.61576 4.46203 4.74441 4.49361 4.87501 4.49361C5.0056 4.49361 5.13425 4.46203 5.25001 4.40157L7.50001 3.11157L9.75001 4.40157C9.86576 4.46203 9.99441 4.49361 10.125 4.49361C10.2556 4.49361 10.3843 4.46203 10.5 4.40157L12 3.54657V14.2491C12.002 14.5049 12.0477 14.7586 12.135 14.9991H3.75001ZM15 14.2491C15 14.448 14.921 14.6388 14.7803 14.7794C14.6397 14.9201 14.4489 14.9991 14.25 14.9991C14.0511 14.9991 13.8603 14.9201 13.7197 14.7794C13.579 14.6388 13.5 14.448 13.5 14.2491V10.4991H15V14.2491Z'
            fill='#6071B5'
          />
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M3.75001 14.9991C3.55109 14.9991 3.36033 14.9201 3.21968 14.7794C3.07902 14.6388 3.00001 14.448 3.00001 14.2491V3.54657L4.50001 4.40157C4.61576 4.46203 4.74441 4.49361 4.87501 4.49361C5.0056 4.49361 5.13425 4.46203 5.25001 4.40157L7.50001 3.11157L9.75001 4.40157C9.86576 4.46203 9.99441 4.49361 10.125 4.49361C10.2556 4.49361 10.3843 4.46203 10.5 4.40157L12 3.54657V14.2491C12.002 14.5049 12.0477 14.7586 12.135 14.9991H3.75001ZM9.00001 7.87407H7.12501C7.02555 7.87407 6.93017 7.91358 6.85984 7.98391C6.78951 8.05424 6.75001 8.14962 6.75001 8.24907C6.75001 8.34853 6.78951 8.44391 6.85984 8.51424C6.93017 8.58457 7.02555 8.62407 7.12501 8.62407H7.87501C8.33999 8.62361 8.78856 8.79593 9.13363 9.10759C9.47871 9.41925 9.69567 9.84801 9.7424 10.3106C9.78913 10.7733 9.66229 11.2368 9.38651 11.6111C9.11073 11.9855 8.70569 12.244 8.25001 12.3366V12.7491C8.25001 12.948 8.17099 13.1388 8.03034 13.2794C7.88968 13.4201 7.69892 13.4991 7.50001 13.4991C7.30109 13.4991 7.11033 13.4201 6.96968 13.2794C6.82902 13.1388 6.75001 12.948 6.75001 12.7491V12.3741H6.00001C5.80109 12.3741 5.61033 12.2951 5.46968 12.1544C5.32902 12.0138 5.25001 11.823 5.25001 11.6241C5.25001 11.4252 5.32902 11.2344 5.46968 11.0937C5.61033 10.9531 5.80109 10.8741 6.00001 10.8741H7.87501C7.97446 10.8741 8.06984 10.8346 8.14017 10.7642C8.2105 10.6939 8.25001 10.5985 8.25001 10.4991C8.25001 10.3996 8.2105 10.3042 8.14017 10.2339C8.06984 10.1636 7.97446 10.1241 7.87501 10.1241H7.12501C6.66002 10.1245 6.21146 9.95222 5.86638 9.64056C5.52131 9.3289 5.30434 8.90014 5.25761 8.43751C5.21088 7.97488 5.33772 7.51139 5.6135 7.13702C5.88928 6.76265 6.29432 6.5041 6.75001 6.41157V5.99907C6.75001 5.80016 6.82902 5.6094 6.96968 5.46874C7.11033 5.32809 7.30109 5.24907 7.50001 5.24907C7.69892 5.24907 7.88968 5.32809 8.03034 5.46874C8.17099 5.6094 8.25001 5.80016 8.25001 5.99907V6.37407H9.00001C9.19892 6.37407 9.38968 6.45309 9.53034 6.59374C9.67099 6.7344 9.75001 6.92516 9.75001 7.12407C9.75001 7.32299 9.67099 7.51375 9.53034 7.6544C9.38968 7.79506 9.19892 7.87407 9.00001 7.87407Z'
            fill='#6071B5'
          />
          <path
            d='M7.12494 7.875H8.99994C9.19885 7.875 9.38961 7.79598 9.53027 7.65533C9.67092 7.51468 9.74994 7.32391 9.74994 7.125C9.74994 6.92609 9.67092 6.73532 9.53027 6.59467C9.38961 6.45402 9.19885 6.375 8.99994 6.375H8.24994V6C8.24994 5.80109 8.17092 5.61032 8.03027 5.46967C7.88961 5.32902 7.69885 5.25 7.49994 5.25C7.30102 5.25 7.11026 5.32902 6.96961 5.46967C6.82895 5.61032 6.74994 5.80109 6.74994 6V6.4125C6.29425 6.50503 5.88921 6.76358 5.61343 7.13795C5.33765 7.51232 5.21081 7.97581 5.25754 8.43844C5.30427 8.90106 5.52124 9.32983 5.86631 9.64149C6.21139 9.95315 6.65995 10.1255 7.12494 10.125H7.87494C7.97439 10.125 8.06977 10.1645 8.1401 10.2348C8.21043 10.3052 8.24994 10.4005 8.24994 10.5C8.24994 10.5995 8.21043 10.6948 8.1401 10.7652C8.06977 10.8355 7.97439 10.875 7.87494 10.875H5.99994C5.80102 10.875 5.61026 10.954 5.46961 11.0947C5.32895 11.2353 5.24994 11.4261 5.24994 11.625C5.24994 11.8239 5.32895 12.0147 5.46961 12.1553C5.61026 12.296 5.80102 12.375 5.99994 12.375H6.74994V12.75C6.74994 12.9489 6.82895 13.1397 6.96961 13.2803C7.11026 13.421 7.30102 13.5 7.49994 13.5C7.69885 13.5 7.88961 13.421 8.03027 13.2803C8.17092 13.1397 8.24994 12.9489 8.24994 12.75V12.3375C8.70562 12.245 9.11066 11.9864 9.38644 11.6121C9.66222 11.2377 9.78906 10.7742 9.74233 10.3116C9.6956 9.84894 9.47864 9.42018 9.13356 9.10852C8.78849 8.79686 8.33992 8.62453 7.87494 8.625H7.12494C7.02548 8.625 6.9301 8.58549 6.85977 8.51517C6.78944 8.44484 6.74994 8.34946 6.74994 8.25C6.74994 8.15054 6.78944 8.05516 6.85977 7.98484C6.9301 7.91451 7.02548 7.875 7.12494 7.875Z'
            fill='white'
          />
        </svg>
      );
    case 'trash-red':
      return (
        <svg
          className={props.className}
          width='19'
          height='19'
          viewBox='0 0 19 19'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g clipPath='url(#clip0_2404_27933)'>
            <path
              d='M3.5 5.75H15.5'
              stroke='#ED1343'
              stroke-width='1.5'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
            <path
              d='M8 8.75V13.25'
              stroke='#ED1343'
              stroke-width='1.5'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
            <path
              d='M11 8.75V13.25'
              stroke='#ED1343'
              stroke-width='1.5'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
            <path
              d='M4.25 5.75L5 14.75C5 15.1478 5.15804 15.5294 5.43934 15.8107C5.72064 16.092 6.10218 16.25 6.5 16.25H12.5C12.8978 16.25 13.2794 16.092 13.5607 15.8107C13.842 15.5294 14 15.1478 14 14.75L14.75 5.75'
              stroke='#ED1343'
              stroke-width='1.5'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
            <path
              d='M7.25 5.75V3.5C7.25 3.30109 7.32902 3.11032 7.46967 2.96967C7.61032 2.82902 7.80109 2.75 8 2.75H11C11.1989 2.75 11.3897 2.82902 11.5303 2.96967C11.671 3.11032 11.75 3.30109 11.75 3.5V5.75'
              stroke='#ED1343'
              stroke-width='1.5'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
          </g>
          <defs>
            <clipPath id='clip0_2404_27933'>
              <rect
                width='18'
                height='18'
                fill='white'
                transform='translate(0.5 0.5)'
              />
            </clipPath>
          </defs>
        </svg>
      );
    case 'options':
      return (
        <svg
          className={props.className}
          width='19'
          height='19'
          viewBox='0 0 19 19'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g clipPath='url(#clip0_2404_27951)'>
            <path
              d='M8.75 9.5C8.75 9.69891 8.82902 9.88968 8.96967 10.0303C9.11032 10.171 9.30109 10.25 9.5 10.25C9.69891 10.25 9.88968 10.171 10.0303 10.0303C10.171 9.88968 10.25 9.69891 10.25 9.5C10.25 9.30109 10.171 9.11032 10.0303 8.96967C9.88968 8.82902 9.69891 8.75 9.5 8.75C9.30109 8.75 9.11032 8.82902 8.96967 8.96967C8.82902 9.11032 8.75 9.30109 8.75 9.5Z'
              fill='#3F3F41'
              stroke='#3F3F41'
              stroke-width='2'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
            <path
              d='M8.75 14.75C8.75 14.9489 8.82902 15.1397 8.96967 15.2803C9.11032 15.421 9.30109 15.5 9.5 15.5C9.69891 15.5 9.88968 15.421 10.0303 15.2803C10.171 15.1397 10.25 14.9489 10.25 14.75C10.25 14.5511 10.171 14.3603 10.0303 14.2197C9.88968 14.079 9.69891 14 9.5 14C9.30109 14 9.11032 14.079 8.96967 14.2197C8.82902 14.3603 8.75 14.5511 8.75 14.75Z'
              fill='#3F3F41'
              stroke='#3F3F41'
              stroke-width='2'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
            <path
              d='M8.75 4.25C8.75 4.44891 8.82902 4.63968 8.96967 4.78033C9.11032 4.92098 9.30109 5 9.5 5C9.69891 5 9.88968 4.92098 10.0303 4.78033C10.171 4.63968 10.25 4.44891 10.25 4.25C10.25 4.05109 10.171 3.86032 10.0303 3.71967C9.88968 3.57902 9.69891 3.5 9.5 3.5C9.30109 3.5 9.11032 3.57902 8.96967 3.71967C8.82902 3.86032 8.75 4.05109 8.75 4.25Z'
              fill='#3F3F41'
              stroke='#3F3F41'
              stroke-width='2'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
          </g>
          <defs>
            <clipPath id='clip0_2404_27951'>
              <rect
                width='18'
                height='18'
                fill='white'
                transform='translate(0.5 0.5)'
              />
            </clipPath>
          </defs>
        </svg>
      );
    case 'options-gray':
      return (
        <svg
          className={props.className}
          width='19'
          height='19'
          viewBox='0 0 19 19'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g clipPath='url(#clip0_2404_27951)'>
            <path
              d='M8.75 9.5C8.75 9.69891 8.82902 9.88968 8.96967 10.0303C9.11032 10.171 9.30109 10.25 9.5 10.25C9.69891 10.25 9.88968 10.171 10.0303 10.0303C10.171 9.88968 10.25 9.69891 10.25 9.5C10.25 9.30109 10.171 9.11032 10.0303 8.96967C9.88968 8.82902 9.69891 8.75 9.5 8.75C9.30109 8.75 9.11032 8.82902 8.96967 8.96967C8.82902 9.11032 8.75 9.30109 8.75 9.5Z'
              fill='#ABABAB'
              stroke='#ABABAB'
              stroke-width='2'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
            <path
              d='M8.75 14.75C8.75 14.9489 8.82902 15.1397 8.96967 15.2803C9.11032 15.421 9.30109 15.5 9.5 15.5C9.69891 15.5 9.88968 15.421 10.0303 15.2803C10.171 15.1397 10.25 14.9489 10.25 14.75C10.25 14.5511 10.171 14.3603 10.0303 14.2197C9.88968 14.079 9.69891 14 9.5 14C9.30109 14 9.11032 14.079 8.96967 14.2197C8.82902 14.3603 8.75 14.5511 8.75 14.75Z'
              fill='#ABABAB'
              stroke='#ABABAB'
              stroke-width='2'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
            <path
              d='M8.75 4.25C8.75 4.44891 8.82902 4.63968 8.96967 4.78033C9.11032 4.92098 9.30109 5 9.5 5C9.69891 5 9.88968 4.92098 10.0303 4.78033C10.171 4.63968 10.25 4.44891 10.25 4.25C10.25 4.05109 10.171 3.86032 10.0303 3.71967C9.88968 3.57902 9.69891 3.5 9.5 3.5C9.30109 3.5 9.11032 3.57902 8.96967 3.71967C8.82902 3.86032 8.75 4.05109 8.75 4.25Z'
              fill='#ABABAB'
              stroke='#ABABAB'
              stroke-width='2'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
          </g>
          <defs>
            <clipPath id='clip0_2404_27951'>
              <rect
                width='18'
                height='18'
                fill='white'
                transform='translate(0.5 0.5)'
              />
            </clipPath>
          </defs>
        </svg>
      );
    case 'edit':
      return (
        <svg
          className={props.className}
          width='19'
          height='19'
          viewBox='0 0 19 19'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g clipPath='url(#clip0_2404_27945)'>
            <path
              d='M3.5 15.5002H6.5L14.375 7.62523C14.572 7.42824 14.7282 7.19439 14.8348 6.93702C14.9415 6.67965 14.9963 6.4038 14.9963 6.12523C14.9963 5.84665 14.9415 5.5708 14.8348 5.31343C14.7282 5.05606 14.572 4.82221 14.375 4.62523C14.178 4.42824 13.9442 4.27199 13.6868 4.16538C13.4294 4.05878 13.1536 4.00391 12.875 4.00391C12.5964 4.00391 12.3206 4.05878 12.0632 4.16538C11.8058 4.27199 11.572 4.42824 11.375 4.62523L3.5 12.5002V15.5002Z'
              stroke='#6071B5'
              stroke-width='1.5'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
            <path
              d='M10.625 5.375L13.625 8.375'
              stroke='#6071B5'
              stroke-width='1.5'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
            <path
              d='M12.5 14.75H17'
              stroke='#6071B5'
              stroke-width='1.5'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
          </g>
          <defs>
            <clipPath id='clip0_2404_27945'>
              <rect
                width='18'
                height='18'
                fill='white'
                transform='translate(0.5 0.5)'
              />
            </clipPath>
          </defs>
        </svg>
      );
    case 'edit-gray':
      return (
        <svg
          className={props.className}
          width='19'
          height='19'
          viewBox='0 0 19 19'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g clipPath='url(#clip0_3365_27130)'>
            <path
              d='M3.5 15.5002H6.5L14.375 7.62523C14.572 7.42824 14.7282 7.19439 14.8348 6.93702C14.9415 6.67965 14.9963 6.4038 14.9963 6.12523C14.9963 5.84665 14.9415 5.5708 14.8348 5.31343C14.7282 5.05606 14.572 4.82221 14.375 4.62523C14.178 4.42824 13.9442 4.27199 13.6868 4.16538C13.4294 4.05878 13.1536 4.00391 12.875 4.00391C12.5964 4.00391 12.3206 4.05878 12.0632 4.16538C11.8058 4.27199 11.572 4.42824 11.375 4.62523L3.5 12.5002V15.5002Z'
              stroke='#ABABAB'
              stroke-width='1.5'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
            <path
              d='M10.625 5.375L13.625 8.375'
              stroke='#ABABAB'
              stroke-width='1.5'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
            <path
              d='M12.5 14.75H17'
              stroke='#ABABAB'
              stroke-width='1.5'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
          </g>
          <defs>
            <clipPath id='clip0_3365_27130'>
              <rect
                width='18'
                height='18'
                fill='white'
                transform='translate(0.5 0.5)'
              />
            </clipPath>
          </defs>
        </svg>
      );

    case 'approve':
      return (
        <svg
          className={props.className}
          width='19'
          height='19'
          viewBox='0 0 19 19'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g clipPath='url(#clip0_2404_27941)'>
            <path
              d='M4.25 9.5L8 13.25L15.5 5.75'
              stroke={!!color ? color : '#32C967'}
              stroke-width='1.5'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
          </g>
          <defs>
            <clipPath id='clip0_2404_27941'>
              <rect
                width='18'
                height='18'
                fill='white'
                transform='translate(0.5 0.5)'
              />
            </clipPath>
          </defs>
        </svg>
      );

    case 'refund':
      return (
        <svg
          className={props.className}
          width='25'
          height='25'
          viewBox='0 0 25 25'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g clipPath='url(#clip0_3364_24597)'>
            <path
              d='M3.25928 11.3302C3.55313 9.08832 4.65396 7.03043 6.35569 5.5417C8.05742 4.05297 10.2434 3.23547 12.5044 3.24223C14.7654 3.24899 16.9464 4.07955 18.6392 5.57843M3.84029 15.9782C4.67694 18.0788 6.25045 19.8024 8.26628 20.8264C10.2821 21.8504 12.602 22.1047 14.7918 21.5416C16.9816 20.9785 18.8911 19.6366 20.1628 17.7672C20.8847 16.706 21.3731 15.5161 21.6091 14.2751'
              stroke='#B663E9'
              stroke-width='1.4'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
            <path
              d='M16.0264 3.98047C18.1245 4.823 19.8437 6.40133 20.8621 8.42001'
              stroke='#B663E9'
              stroke-width='1.4'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
            <path
              d='M21.7261 5.99986L21.234 8.91016L18.3237 8.41804'
              stroke='#B663E9'
              stroke-width='1.4'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
            <path
              d='M15.2175 9.58872C15.0417 9.28377 14.7863 9.03237 14.4786 8.86143C14.1709 8.69049 13.8225 8.60644 13.4707 8.61829H11.5298C11.0151 8.61829 10.5214 8.82277 10.1575 9.18675C9.79347 9.55073 9.58899 10.0444 9.58899 10.5591C9.58899 11.0739 9.79347 11.5676 10.1575 11.9315C10.5214 12.2955 11.0151 12.5 11.5298 12.5H13.4707C13.9855 12.5 14.4791 12.7045 14.8431 13.0685C15.2071 13.4325 15.4116 13.9261 15.4116 14.4409C15.4116 14.9556 15.2071 15.4493 14.8431 15.8133C14.4791 16.1772 13.9855 16.3817 13.4707 16.3817H11.5298C11.1781 16.3936 10.8297 16.3095 10.522 16.1386C10.2143 15.9676 9.95887 15.7162 9.78308 15.4113'
              stroke='#B663E9'
              stroke-width='1.5'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
            <path
              d='M12.5001 7.64844V17.3527'
              stroke='#B663E9'
              stroke-width='1.5'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
            <path
              d='M2.82628 18.3784L3.59021 15.5273L6.44125 16.2913'
              stroke='#B663E9'
              stroke-width='1.4'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
          </g>
          <defs>
            <clipPath id='clip0_3364_24597'>
              <rect
                width='24'
                height='24'
                fill='white'
                transform='translate(0.5 0.5)'
              />
            </clipPath>
          </defs>
        </svg>
      );

    case 'refund-gray':
      return (
        <svg
          className={props.className}
          width='25'
          height='25'
          viewBox='0 0 25 25'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g clipPath='url(#clip0_3364_24597)'>
            <path
              d='M3.25928 11.3302C3.55313 9.08832 4.65396 7.03043 6.35569 5.5417C8.05742 4.05297 10.2434 3.23547 12.5044 3.24223C14.7654 3.24899 16.9464 4.07955 18.6392 5.57843M3.84029 15.9782C4.67694 18.0788 6.25045 19.8024 8.26628 20.8264C10.2821 21.8504 12.602 22.1047 14.7918 21.5416C16.9816 20.9785 18.8911 19.6366 20.1628 17.7672C20.8847 16.706 21.3731 15.5161 21.6091 14.2751'
              stroke='#ABABAB'
              stroke-width='1.4'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
            <path
              d='M16.0264 3.98047C18.1245 4.823 19.8437 6.40133 20.8621 8.42001'
              stroke='#ABABAB'
              stroke-width='1.4'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
            <path
              d='M21.7261 5.99986L21.234 8.91016L18.3237 8.41804'
              stroke='#ABABAB'
              stroke-width='1.4'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
            <path
              d='M15.2175 9.58872C15.0417 9.28377 14.7863 9.03237 14.4786 8.86143C14.1709 8.69049 13.8225 8.60644 13.4707 8.61829H11.5298C11.0151 8.61829 10.5214 8.82277 10.1575 9.18675C9.79347 9.55073 9.58899 10.0444 9.58899 10.5591C9.58899 11.0739 9.79347 11.5676 10.1575 11.9315C10.5214 12.2955 11.0151 12.5 11.5298 12.5H13.4707C13.9855 12.5 14.4791 12.7045 14.8431 13.0685C15.2071 13.4325 15.4116 13.9261 15.4116 14.4409C15.4116 14.9556 15.2071 15.4493 14.8431 15.8133C14.4791 16.1772 13.9855 16.3817 13.4707 16.3817H11.5298C11.1781 16.3936 10.8297 16.3095 10.522 16.1386C10.2143 15.9676 9.95887 15.7162 9.78308 15.4113'
              stroke='#ABABAB'
              stroke-width='1.5'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
            <path
              d='M12.5001 7.64844V17.3527'
              stroke='#ABABAB'
              stroke-width='1.5'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
            <path
              d='M2.82628 18.3784L3.59021 15.5273L6.44125 16.2913'
              stroke='#ABABAB'
              stroke-width='1.4'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
          </g>
          <defs>
            <clipPath id='clip0_3364_24597'>
              <rect
                width='24'
                height='24'
                fill='white'
                transform='translate(0.5 0.5)'
              />
            </clipPath>
          </defs>
        </svg>
      );
    case 'coins':
      return (
        <svg
          className={props.className}
          xmlns='http://www.w3.org/2000/svg'
          width='24'
          height='25'
          viewBox='0 0 24 25'
          fill='none'
        >
          <path
            d='M17.625 8.57281V8.375C17.625 7.00437 16.6097 5.79219 14.7647 4.9625C13.2066 4.26125 11.1562 3.875 9 3.875C6.84375 3.875 4.79344 4.26125 3.23531 4.9625C1.39031 5.79219 0.375 7.00437 0.375 8.375V12.125C0.375 13.4956 1.39031 14.7078 3.23531 15.5375C4.23794 15.9714 5.29372 16.2702 6.375 16.4263V16.625C6.375 17.9956 7.39031 19.2078 9.23531 20.0375C10.7934 20.7387 12.8438 21.125 15 21.125C17.1562 21.125 19.2066 20.7387 20.7647 20.0375C22.6097 19.2078 23.625 17.9956 23.625 16.625V12.875C23.625 10.7994 21.2541 9.1325 17.625 8.57281ZM21.375 12.875C21.375 13.6016 19.3341 14.9825 15.5803 15.1138C16.9059 14.3188 17.625 13.2781 17.625 12.125V10.8538C20.0513 11.2953 21.375 12.2638 21.375 12.875ZM10.0659 14.3403C9.72563 14.3628 9.37031 14.375 9 14.375C8.52375 14.375 8.07281 14.3544 7.64719 14.3178C7.61173 14.3131 7.57606 14.3103 7.54031 14.3094C7.39875 14.2963 7.25906 14.2813 7.125 14.2644V12.7747C7.74776 12.8416 8.37366 12.8751 9 12.875C9.62634 12.8751 10.2522 12.8416 10.875 12.7747V14.2644C10.6416 14.2925 10.3997 14.3169 10.1484 14.3347C10.125 14.3356 10.0931 14.3375 10.0659 14.3403ZM15.375 11.4819V12.125C15.375 12.5731 14.5988 13.2697 13.125 13.7694V12.3631C13.6861 12.2159 14.2344 12.0237 14.7647 11.7884C14.9797 11.6916 15.1831 11.5894 15.375 11.4819ZM9 6.125C13.125 6.125 15.375 7.61094 15.375 8.375C15.375 9.13906 13.125 10.625 9 10.625C4.875 10.625 2.625 9.13906 2.625 8.375C2.625 7.61094 4.875 6.125 9 6.125ZM2.625 12.125V11.4819C2.8175 11.5887 3.02094 11.6906 3.23531 11.7875C3.76557 12.0227 4.3139 12.2149 4.875 12.3622V13.7684C3.40125 13.2697 2.625 12.5731 2.625 12.125ZM8.625 16.625H9C9.34 16.625 9.67656 16.615 10.0097 16.595C10.2878 16.6931 10.5763 16.7825 10.875 16.8631V18.2694C9.40125 17.7697 8.625 17.0731 8.625 16.625ZM13.125 18.7644V17.2756C13.7478 17.3423 14.3737 17.3755 15 17.375C15.6263 17.3751 16.2522 17.3416 16.875 17.2747V18.7644C15.6294 18.9119 14.3706 18.9119 13.125 18.7644ZM19.125 18.2694V16.8631C19.6861 16.7159 20.2344 16.5237 20.7647 16.2884C20.9797 16.1922 21.1831 16.0903 21.375 15.9828V16.625C21.375 17.0731 20.5987 17.7697 19.125 18.2694Z'
            fill='#6071B5'
          />
        </svg>
      );

    case 'arrow-left':
      return (
        <svg
          className={props.className}
          width='21'
          height='21'
          viewBox='0 0 21 21'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M13.5 16.5L7.5 10.548L13.5 4.5'
            stroke='#6071B5'
            stroke-width='1.5'
            stroke-linecap='round'
            stroke-linejoin='round'
          />
        </svg>
      );

    case 'arrow-right':
      return (
        <svg
          className={props.className}
          width='21'
          height='21'
          viewBox='0 0 21 21'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M7.5 4.5L13.5 10.452L7.5 16.5'
            stroke='#6071B5'
            stroke-width='1.5'
            stroke-linecap='round'
            stroke-linejoin='round'
          />
        </svg>
      );

    case 'arrow-up-down':
      return (
        <svg
          className={props.className}
          width='18'
          height='18'
          viewBox='0 0 18 18'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M5.69107 6.73701L8.44539 2.60553C8.64962 2.29918 9.06354 2.2164 9.36989 2.42063C9.44312 2.46945 9.50597 2.5323 9.55479 2.60553L12.3091 6.73701C12.5133 7.04337 12.4306 7.45728 12.1242 7.66151C12.0147 7.73452 11.886 7.77348 11.7544 7.77348H6.24577C5.87758 7.77348 5.5791 7.475 5.5791 7.10681C5.5791 6.9752 5.61806 6.84653 5.69107 6.73701Z'
            fill='#3F3F41'
          />
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M12.3089 10.8099L9.55461 14.9413C9.35038 15.2477 8.93646 15.3305 8.63011 15.1262C8.55688 15.0774 8.49403 15.0146 8.44521 14.9413L5.69089 10.8099C5.48665 10.5035 5.56944 10.0896 5.87579 9.88536C5.9853 9.81235 6.11397 9.77339 6.24559 9.77339L11.7542 9.77339C12.1224 9.77339 12.4209 10.0719 12.4209 10.4401C12.4209 10.5717 12.3819 10.7003 12.3089 10.8099Z'
            fill='#3F3F41'
          />
        </svg>
      );

    case 'clock-dark':
      return (
        <svg
          className={props.className}
          width='18'
          height='18'
          viewBox='0 0 18 18'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M9 1.5C4.8675 1.5 1.5 4.8675 1.5 9C1.5 13.1325 4.8675 16.5 9 16.5C13.1325 16.5 16.5 13.1325 16.5 9C16.5 4.8675 13.1325 1.5 9 1.5ZM12.2625 11.6775C12.1575 11.8575 11.97 11.955 11.775 11.955C11.6775 11.955 11.58 11.9325 11.49 11.8725L9.165 10.485C8.5875 10.14 8.16 9.3825 8.16 8.715V5.64C8.16 5.3325 8.415 5.0775 8.7225 5.0775C9.03 5.0775 9.285 5.3325 9.285 5.64V8.715C9.285 8.985 9.51 9.3825 9.7425 9.5175L12.0675 10.905C12.3375 11.0625 12.4275 11.4075 12.2625 11.6775Z'
            fill='#0C0019'
          />
        </svg>
      );
    case 'clock-white':
      return (
        <svg
          className={props.className}
          width='20'
          height='20'
          viewBox='0 0 20 20'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g clipPath='url(#clip0_4096_48236)'>
            <path
              d='M2.5 10C2.5 10.9849 2.69399 11.9602 3.0709 12.8701C3.44781 13.7801 4.00026 14.6069 4.6967 15.3033C5.39314 15.9997 6.21993 16.5522 7.12987 16.9291C8.03982 17.306 9.01509 17.5 10 17.5C10.9849 17.5 11.9602 17.306 12.8701 16.9291C13.7801 16.5522 14.6069 15.9997 15.3033 15.3033C15.9997 14.6069 16.5522 13.7801 16.9291 12.8701C17.306 11.9602 17.5 10.9849 17.5 10C17.5 9.01509 17.306 8.03982 16.9291 7.12987C16.5522 6.21993 15.9997 5.39314 15.3033 4.6967C14.6069 4.00026 13.7801 3.44781 12.8701 3.0709C11.9602 2.69399 10.9849 2.5 10 2.5C9.01509 2.5 8.03982 2.69399 7.12987 3.0709C6.21993 3.44781 5.39314 4.00026 4.6967 4.6967C4.00026 5.39314 3.44781 6.21993 3.0709 7.12987C2.69399 8.03982 2.5 9.01509 2.5 10Z'
              stroke='white'
              stroke-width='1.5'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
            <path
              d='M10.0833 10H13'
              stroke='white'
              stroke-width='1.5'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
            <path
              d='M10 5.83301V9.99967'
              stroke='white'
              stroke-width='1.5'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
          </g>
          <defs>
            <clipPath id='clip0_4096_48236'>
              <rect width='20' height='20' fill='white' />
            </clipPath>
          </defs>
        </svg>
      );
    case 'layer-up':
      return (
        <svg
          className={props.className}
          width='21'
          height='20'
          viewBox='0 0 21 20'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M7.53355 10.0625L2.96499 12.5665C2.68118 12.722 2.69964 13.1357 2.99617 13.2654L10.8173 16.6852C10.918 16.7292 11.0325 16.7287 11.1327 16.6838L18.752 13.273C19.0479 13.1405 19.0621 12.7257 18.776 12.5732L14.0629 10.0625'
            stroke='#fcfcfd'
            stroke-width='1.46159'
            stroke-linecap='round'
          />
          <path
            d='M10.875 3.63477L10.875 11.9071'
            stroke='#fcfcfd'
            stroke-width='1.46159'
            stroke-linecap='round'
            stroke-linejoin='round'
          />
          <path
            d='M8.17188 5.94898L10.8748 3.24609L13.5776 5.94898'
            stroke='#fcfcfd'
            stroke-width='1.46159'
            stroke-linecap='round'
            stroke-linejoin='round'
          />
        </svg>
      );
    case 'layer-up-to-top':
      return (
        <svg
          className={props.className}
          width='21'
          height='20'
          viewBox='0 0 21 20'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M3.92286 14.0703L2.71695 14.7313C2.43313 14.8868 2.45159 15.3005 2.74813 15.4302L10.5693 18.85C10.6699 18.894 10.7845 18.8935 10.8847 18.8486L18.5039 15.4378C18.7998 15.3053 18.8141 14.8905 18.5279 14.738L17.2745 14.0703'
            stroke='#fcfcfd'
            stroke-width='1.46159'
            stroke-linecap='round'
          />
          <path
            d='M7.2855 7.89648L2.71695 10.4004C2.43313 10.556 2.45159 10.9697 2.74813 11.0993L10.5693 14.5192C10.6699 14.5632 10.7845 14.5627 10.8847 14.5178L18.5039 11.107C18.7998 10.9745 18.8141 10.5597 18.5279 10.4072L13.8148 7.89648'
            stroke='#fcfcfd'
            stroke-width='1.46159'
            stroke-linecap='round'
          />
          <path
            d='M10.625 1.46875L10.625 9.74107'
            stroke='#fcfcfd'
            stroke-width='1.46159'
            stroke-linecap='round'
            stroke-linejoin='round'
          />
          <path
            d='M7.92188 3.78296L10.6248 1.08008L13.3276 3.78296'
            stroke='#fcfcfd'
            stroke-width='1.46159'
            stroke-linecap='round'
            stroke-linejoin='round'
          />
        </svg>
      );
    case 'layer-down':
      return (
        <svg
          className={props.className}
          width='21'
          height='20'
          viewBox='0 0 21 20'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M13.7145 9.9375L18.2831 7.43355C18.5669 7.27799 18.5484 6.86431 18.2519 6.73465L10.4307 3.3148C10.3301 3.2708 10.2155 3.27129 10.1153 3.31617L2.49609 6.72702C2.20017 6.8595 2.18594 7.27432 2.47209 7.42676L7.18516 9.9375'
            stroke='#fcfcfd'
            stroke-width='1.46159'
            stroke-linecap='round'
          />
          <path
            d='M10.373 16.3652L10.373 8.09291'
            stroke='#fcfcfd'
            stroke-width='1.46159'
            stroke-linecap='round'
            stroke-linejoin='round'
          />
          <path
            d='M13.0762 14.051L10.3733 16.7539L7.6704 14.051'
            stroke='#fcfcfd'
            stroke-width='1.46159'
            stroke-linecap='round'
            stroke-linejoin='round'
          />
        </svg>
      );
    case 'layer-down-to-bottom':
      return (
        <svg
          className={props.className}
          width='21'
          height='20'
          viewBox='0 0 21 20'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M16.8291 5.92969L18.035 5.26874C18.3188 5.11319 18.3004 4.69951 18.0038 4.56984L10.1827 1.14999C10.082 1.10599 9.9675 1.10649 9.86725 1.15137L2.24805 4.56222C1.95212 4.6947 1.9379 5.10951 2.22405 5.26195L3.47749 5.92969'
            stroke='#fcfcfd'
            stroke-width='1.46159'
            stroke-linecap='round'
          />
          <path
            d='M13.4664 12.1035L18.035 9.59956C18.3188 9.44401 18.3004 9.03033 18.0038 8.90066L10.1827 5.48081C10.082 5.43681 9.9675 5.43731 9.86725 5.48219L2.24805 8.89304C1.95212 9.02551 1.9379 9.44033 2.22405 9.59277L6.93711 12.1035'
            stroke='#fcfcfd'
            stroke-width='1.46159'
            stroke-linecap='round'
          />
          <path
            d='M10.127 18.5312L10.127 10.2589'
            stroke='#fcfcfd'
            stroke-width='1.46159'
            stroke-linecap='round'
            stroke-linejoin='round'
          />
          <path
            d='M12.8301 16.217L10.1272 18.9199L7.42431 16.217'
            stroke='#fcfcfd'
            stroke-width='1.46159'
            stroke-linecap='round'
            stroke-linejoin='round'
          />
        </svg>
      );
    case 'rubbish-bin':
      return (
        <svg
          className={props.className}
          width='20'
          height='20'
          viewBox='0 0 20 20'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g clipPath='url(#clip0_3160_80408)'>
            <path
              d='M3.33398 5.83203H16.6673'
              stroke='#0C0019'
              stroke-width='1.5'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
            <path
              d='M8.33398 9.16797V14.168'
              stroke='#0C0019'
              stroke-width='1.5'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
            <path
              d='M11.666 9.16797V14.168'
              stroke='#0C0019'
              stroke-width='1.5'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
            <path
              d='M4.16602 5.83203L4.99935 15.832C4.99935 16.2741 5.17494 16.698 5.4875 17.0105C5.80007 17.3231 6.22399 17.4987 6.66602 17.4987H13.3327C13.7747 17.4987 14.1986 17.3231 14.5112 17.0105C14.8238 16.698 14.9994 16.2741 14.9994 15.832L15.8327 5.83203'
              stroke='#0C0019'
              stroke-width='1.5'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
            <path
              d='M7.5 5.83333V3.33333C7.5 3.11232 7.5878 2.90036 7.74408 2.74408C7.90036 2.5878 8.11232 2.5 8.33333 2.5H11.6667C11.8877 2.5 12.0996 2.5878 12.2559 2.74408C12.4122 2.90036 12.5 3.11232 12.5 3.33333V5.83333'
              stroke='#0C0019'
              stroke-width='1.5'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
          </g>
          <defs>
            <clipPath id='clip0_3160_80408'>
              <rect width='20' height='20' fill='white' />
            </clipPath>
          </defs>
        </svg>
      );
    case 'text-style-bold':
      return (
        <svg
          className={props.className}
          style={{ padding: '5px 0' }}
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 9.470000267028809 27.030000686645508 35.78999710083008'
          data-asc='0.9052734375'
        >
          <g fill='#000000'>
            <g fill='#000000' transform='translate(0, 0)'>
              <path d='M0 45.26L0 9.47L13.43 9.47Q17.53 9.47 20.01 10.56Q22.49 11.65 23.89 13.90Q25.29 16.16 25.29 18.63Q25.29 20.92 24.05 22.95Q22.80 24.98 20.29 26.22Q23.54 27.17 25.28 29.47Q27.03 31.76 27.03 34.89Q27.03 37.40 25.96 39.56Q24.90 41.72 23.34 42.90Q21.78 44.07 19.42 44.67Q17.07 45.26 13.65 45.26L0 45.26M4.74 24.51L12.48 24.51Q15.63 24.51 16.99 24.10Q18.80 23.56 19.71 22.31Q20.63 21.07 20.63 19.19Q20.63 17.41 19.78 16.05Q18.92 14.70 17.33 14.20Q15.75 13.70 11.89 13.70L4.74 13.70L4.74 24.51M4.74 41.04L13.65 41.04Q15.94 41.04 16.87 40.87Q18.51 40.58 19.60 39.89Q20.70 39.21 21.41 37.90Q22.12 36.60 22.12 34.89Q22.12 32.89 21.09 31.41Q20.07 29.93 18.25 29.33Q16.43 28.74 13.01 28.74L4.74 28.74L4.74 41.04Z' />
            </g>
            <g fill='#000000' transform='translate(0, 60.595703125)'>
              <path d='' />
            </g>
          </g>
        </svg>
      );
    case 'text-style-italic':
      return (
        <svg
          className={props.className}
          style={{ padding: '5px 0' }}
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 20.420000076293945 11.149999618530273 29.579999923706055'
          data-asc='1'
        >
          <g fill='#000000'>
            <g fill='#000000' transform='translate(0, 0)'>
              <path d='M0 50L5.21 29.17L8.96 29.17L3.75 50L0 50M8.37 25.42Q7.43 25.42 6.79 24.79Q6.15 24.17 6.15 23.23Q6.15 22.12 7.00 21.27Q7.85 20.42 8.92 20.42Q9.86 20.42 10.50 21.04Q11.15 21.67 11.15 22.60Q11.15 23.72 10.31 24.57Q9.48 25.42 8.37 25.42Z' />
            </g>
            <g fill='#000000' transform='translate(0, 66.66666666666666)'>
              <path d='' />
            </g>
          </g>
        </svg>
      );
    case 'text-style-small-caps':
      return (
        <svg
          className={props.className}
          style={{ padding: '5px 0' }}
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 9.470000267028809 59.11000061035156 36.37999725341797'
          data-asc='0.9052734375'
        >
          <g fill='#000000'>
            <g fill='#000000' transform='translate(0, 0)'>
              <path d='M0 45.26L13.75 9.47L18.85 9.47L33.50 45.26L28.10 45.26L23.93 34.42L8.96 34.42L5.03 45.26L0 45.26M10.33 30.57L22.46 30.57L18.73 20.65Q17.02 16.14 16.19 13.23Q15.50 16.67 14.26 20.07L10.33 30.57ZM53.64 42.07Q51.20 44.14 48.94 45.00Q46.68 45.85 44.09 45.85Q39.82 45.85 37.52 43.76Q35.23 41.67 35.23 38.43Q35.23 36.52 36.10 34.95Q36.96 33.37 38.37 32.42Q39.77 31.47 41.53 30.98Q42.82 30.64 45.43 30.32Q50.76 29.69 53.27 28.81Q53.30 27.91 53.30 27.66Q53.30 24.98 52.05 23.88Q50.37 22.39 47.05 22.39Q43.95 22.39 42.47 23.47Q40.99 24.56 40.28 27.32L35.99 26.73Q36.57 23.97 37.92 22.28Q39.26 20.58 41.80 19.67Q44.34 18.75 47.68 18.75Q51.00 18.75 53.08 19.53Q55.15 20.31 56.13 21.50Q57.10 22.68 57.50 24.49Q57.71 25.61 57.71 28.54L57.71 34.40Q57.71 40.53 58.00 42.15Q58.28 43.77 59.11 45.26L54.52 45.26Q53.83 43.90 53.64 42.07M53.27 32.25Q50.88 33.23 46.09 33.91Q43.38 34.30 42.26 34.79Q41.14 35.28 40.53 36.22Q39.92 37.16 39.92 38.31Q39.92 40.06 41.25 41.24Q42.58 42.41 45.14 42.41Q47.68 42.41 49.66 41.30Q51.64 40.19 52.56 38.26Q53.27 36.77 53.27 33.86L53.27 32.25Z' />
            </g>
            <g fill='#000000' transform='translate(0, 60.595703125)'>
              <path d='' />
            </g>
          </g>
        </svg>
      );
    case 'text-align-horizontal-left':
      return (
        <svg
          className={props.className}
          viewBox='0 0 16.00 16.00'
          xmlns='http://www.w3.org/2000/svg'
          fill='#000000'
        >
          <g id='SVGRepo_bgCarrier' stroke-width='0'></g>
          <g
            id='SVGRepo_tracerCarrier'
            stroke-linecap='round'
            stroke-linejoin='round'
            stroke='#CCCCCC'
            stroke-width='0.032'
          ></g>
          <g id='SVGRepo_iconCarrier'>
            {' '}
            <path
              fill-rule='evenodd'
              d='M2 12.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z'
            ></path>{' '}
          </g>
        </svg>
      );
    case 'text-align-horizontal-right':
      return (
        <svg
          className={props.className}
          viewBox='0 0 16 16'
          xmlns='http://www.w3.org/2000/svg'
          fill='#000000'
        >
          <g id='SVGRepo_bgCarrier' stroke-width='0'></g>
          <g
            id='SVGRepo_tracerCarrier'
            stroke-linecap='round'
            stroke-linejoin='round'
          ></g>
          <g id='SVGRepo_iconCarrier'>
            {' '}
            <path
              fill-rule='evenodd'
              d='M6 12.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-4-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm4-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-4-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z'
            ></path>{' '}
          </g>
        </svg>
      );
    case 'text-align-horizontal-center':
      return (
        <svg
          className={props.className}
          viewBox='0 0 16 16'
          xmlns='http://www.w3.org/2000/svg'
          fill='#000000'
        >
          <g id='SVGRepo_bgCarrier' stroke-width='0'></g>
          <g
            id='SVGRepo_tracerCarrier'
            stroke-linecap='round'
            stroke-linejoin='round'
          ></g>
          <g id='SVGRepo_iconCarrier'>
            {' '}
            <path
              fill-rule='evenodd'
              d='M4 12.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z'
            ></path>{' '}
          </g>
        </svg>
      );
    case 'text-align-vertical-top':
      return (
        <svg
          className={props.className}
          width='21'
          height='20'
          viewBox='0 0 21 20'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M4.5 4.42578L16.5 4.42578'
            stroke='#0C0019'
            stroke-width='1.12497'
            stroke-linecap='round'
            stroke-linejoin='round'
          />
          <path
            d='M10.3105 7.0625L10.3105 15.5522'
            stroke='#0C0019'
            stroke-width='1.5'
            stroke-linecap='round'
            stroke-linejoin='round'
          />
          <path
            d='M7.53711 9.43797L10.311 6.66406L13.0849 9.43797'
            stroke='#0C0019'
            stroke-width='1.5'
            stroke-linecap='round'
            stroke-linejoin='round'
          />
        </svg>
      );
    case 'text-align-vertical-middle':
      return (
        <svg
          className={props.className}
          width='21'
          height='20'
          viewBox='0 0 21 20'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M10.5 12.7812L10.5 19.1483'
            stroke='#0C0019'
            stroke-width='1.12497'
            stroke-linecap='round'
            stroke-linejoin='round'
          />
          <path
            d='M8.41992 14.5647L10.5003 12.4844L12.5807 14.5647'
            stroke='#0C0019'
            stroke-width='1.12497'
            stroke-linecap='round'
            stroke-linejoin='round'
          />
          <path
            d='M10.5 7.61719L10.5 1.2501'
            stroke='#0C0019'
            stroke-width='1.12497'
            stroke-linecap='round'
            stroke-linejoin='round'
          />
          <path
            d='M12.5801 5.83369L10.4997 7.91406L8.41934 5.83369'
            stroke='#0C0019'
            stroke-width='1.12497'
            stroke-linecap='round'
            stroke-linejoin='round'
          />
          <path
            d='M4.16602 9.98047L16.166 9.98047'
            stroke='#0C0019'
            stroke-width='1.12497'
            stroke-linecap='round'
            stroke-linejoin='round'
          />
        </svg>
      );
    case 'text-align-vertical-bottom':
      return (
        <svg
          className={props.className}
          width='21'
          height='20'
          viewBox='0 0 21 20'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M4.5 14.4258L16.5 14.4258'
            stroke='#0C0019'
            stroke-width='1.12497'
            stroke-linecap='round'
            stroke-linejoin='round'
          />
          <path
            d='M10.6895 11.4922L10.6895 3.00249'
            stroke='#0C0019'
            stroke-width='1.5'
            stroke-linecap='round'
            stroke-linejoin='round'
          />
          <path
            d='M13.4629 9.11672L10.689 11.8906L7.91507 9.11672'
            stroke='#0C0019'
            stroke-width='1.5'
            stroke-linecap='round'
            stroke-linejoin='round'
          />
        </svg>
      );
    case 'group-people':
      return (
        <svg
          fill='#000000'
          width='22'
          height='22'
          viewBox='0 0 512 512'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g id='SVGRepo_bgCarrier' stroke-width='0'></g>
          <g
            id='SVGRepo_tracerCarrier'
            stroke-linecap='round'
            stroke-linejoin='round'
          ></g>
          <g id='SVGRepo_iconCarrier'>
            <title>ionicons-v5-j</title>
            <path d='M336,256c-20.56,0-40.44-9.18-56-25.84-15.13-16.25-24.37-37.92-26-61-1.74-24.62,5.77-47.26,21.14-63.76S312,80,336,80c23.83,0,45.38,9.06,60.7,25.52,15.47,16.62,23,39.22,21.26,63.63h0c-1.67,23.11-10.9,44.77-26,61C376.44,246.82,356.57,256,336,256Zm66-88h0Z'></path>
            <path d='M467.83,432H204.18a27.71,27.71,0,0,1-22-10.67,30.22,30.22,0,0,1-5.26-25.79c8.42-33.81,29.28-61.85,60.32-81.08C264.79,297.4,299.86,288,336,288c36.85,0,71,9,98.71,26.05,31.11,19.13,52,47.33,60.38,81.55a30.27,30.27,0,0,1-5.32,25.78A27.68,27.68,0,0,1,467.83,432Z'></path>
            <path d='M147,260c-35.19,0-66.13-32.72-69-72.93C76.58,166.47,83,147.42,96,133.45,108.86,119.62,127,112,147,112s38,7.66,50.93,21.57c13.1,14.08,19.5,33.09,18,53.52C213.06,227.29,182.13,260,147,260Z'></path>
            <path d='M212.66,291.45c-17.59-8.6-40.42-12.9-65.65-12.9-29.46,0-58.07,7.68-80.57,21.62C40.93,316,23.77,339.05,16.84,366.88a27.39,27.39,0,0,0,4.79,23.36A25.32,25.32,0,0,0,41.72,400h111a8,8,0,0,0,7.87-6.57c.11-.63.25-1.26.41-1.88,8.48-34.06,28.35-62.84,57.71-83.82a8,8,0,0,0-.63-13.39C216.51,293.42,214.71,292.45,212.66,291.45Z'></path>
          </g>
        </svg>
      );
    case 'history':
      return (
        <svg
          className={props.className}
          xmlns='http://www.w3.org/2000/svg'
          height='24px'
          viewBox='0 -960 960 960'
          width='24px'
          fill='#3F3F41'
        >
          <path d='M480-120q-138 0-240.5-91.5T122-440h82q14 104 92.5 172T480-200q117 0 198.5-81.5T760-480q0-117-81.5-198.5T480-760q-69 0-129 32t-101 88h110v80H120v-240h80v94q51-64 124.5-99T480-840q75 0 140.5 28.5t114 77q48.5 48.5 77 114T840-480q0 75-28.5 140.5t-77 114q-48.5 48.5-114 77T480-120Zm112-192L440-464v-216h80v184l128 128-56 56Z' />
        </svg>
      );
    case 'clear':
      return (
        <svg
          fill='#000000'
          viewBox='0 0 24 24'
          id='a2495f07-7746-4c27-a7cc-72112ecafc37'
          data-name='Livello 1'
          xmlns='http://www.w3.org/2000/svg'
        >
          <polygon
            id='c8ef3de6-eeb3-441f-adf3-4bc928b83c76'
            data-name='clear'
            points='18.41 2.36 12.05 8.73 5.69 2.36 2.86 5.19 9.22 11.56 2.86 17.92 5.69 20.75 12.05 14.38 18.41 20.75 21.24 17.92 14.88 11.56 21.24 5.19 18.41 2.36'
          ></polygon>
        </svg>
      );
    case 'tick':
      return (
        <svg
          width='36px'
          height='36px'
          viewBox='0 0 36 36'
          version='1.1'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g
            id='Assets'
            stroke='none'
            stroke-width='1'
            fill='none'
            fill-rule='evenodd'
          >
            <g transform='translate(-195.000000, -592.000000)' id='ic_tick'>
              <g transform='translate(195.000000, 592.000000)'>
                <circle id='Oval' cx='18' cy='18' r='18'></circle>
                <polyline
                  id='Tick'
                  stroke='#FFFFFF'
                  stroke-width='1.5'
                  stroke-linecap='round'
                  stroke-linejoin='round'
                  points='12 17.195011 16.5029221 22 24 14'
                ></polyline>
              </g>
            </g>
          </g>
        </svg>
      );
    case 'emails':
      return (
        <svg
          className={props.className}
          width='22px'
          height='22px'
          fill='currentColor'
          version='1.1'
          id='Capa_1'
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 0 489.5 489.5'
        >
          <g>
            <g>
              <path
                d='M12.3,392.95h158.1l62.7,83c2.3,3,5.8,4.8,9.6,4.9c0.1,0,0.1,0,0.2,0c3.7,0,7.2-1.7,9.5-4.6l67.2-83.3h157.6
                c6.8,0,12.3-5.5,12.3-12.3V20.95c0-6.8-5.5-12.3-12.3-12.3H12.3C5.5,8.65,0,14.15,0,20.95v359.7C0,387.45,5.5,392.95,12.3,392.95z
                M24.5,33.25h440.4v335.2H313.7c-3.7,0-7.2,1.7-9.5,4.6l-61,75.7l-56.9-75.4c-2.3-3.1-5.9-4.9-9.8-4.9h-152
                C24.5,368.45,24.5,33.25,24.5,33.25z'
              />
              <path
                d='M78.3,112.65h332.8c6.8,0,12.3-5.5,12.3-12.3s-5.5-12.3-12.3-12.3H78.3c-6.8,0-12.3,5.5-12.3,12.3
                C66,107.15,71.5,112.65,78.3,112.65z'
              />
              <path
                d='M78.3,179.55h332.8c6.8,0,12.3-5.5,12.3-12.3s-5.5-12.3-12.3-12.3H78.3c-6.8,0-12.3,5.5-12.3,12.3
                C66,174.05,71.5,179.55,78.3,179.55z'
              />
              <path
                d='M78.3,246.55h332.8c6.8,0,12.3-5.5,12.3-12.3s-5.5-12.3-12.3-12.3H78.3c-6.8,0-12.3,5.5-12.3,12.3
                C66,241.05,71.5,246.55,78.3,246.55z'
              />
              <path
                d='M257,301.25c0-6.8-5.5-12.3-12.3-12.3H78.3c-6.8,0-12.3,5.5-12.3,12.3s5.5,12.3,12.3,12.3h166.4
                C251.5,313.45,257,307.95,257,301.25z'
              />
            </g>
          </g>
        </svg>
      );

    case 'promoter':
      return (
        <svg
          className={props.className}
          xmlns='http://www.w3.org/2000/svg'
          width='24px'
          height='24px'
          viewBox='0 0 24 24'
          fill='none'
        >
          <circle
            cx='9'
            cy='9'
            r='2'
            stroke='currentColor'
            stroke-width='1.5'
          />
          <path
            d='M13 15C13 16.1046 13 17 9 17C5 17 5 16.1046 5 15C5 13.8954 6.79086 13 9 13C11.2091 13 13 13.8954 13 15Z'
            stroke='currentColor'
            stroke-width='1.5'
          />
          <path
            d='M22 12C22 15.7712 22 17.6569 20.8284 18.8284C19.6569 20 17.7712 20 14 20H10C6.22876 20 4.34315 20 3.17157 18.8284C2 17.6569 2 15.7712 2 12C2 8.22876 2 6.34315 3.17157 5.17157C4.34315 4 6.22876 4 10 4H14C17.7712 4 19.6569 4 20.8284 5.17157C21.298 5.64118 21.5794 6.2255 21.748 7'
            stroke='currentColor'
            stroke-width='1.5'
            stroke-linecap='round'
          />
          <path
            d='M19 12H15'
            stroke='currentColor'
            stroke-width='1.5'
            stroke-linecap='round'
          />
          <path
            d='M19 9H14'
            stroke='currentColor'
            stroke-width='1.5'
            stroke-linecap='round'
          />
          <path
            d='M19 15H16'
            stroke='currentColor'
            stroke-width='1.5'
            stroke-linecap='round'
          />
        </svg>
      );

    case 'search':
      return (
        <svg
          className={props.className}
          xmlns='http://www.w3.org/2000/svg'
          fill='#000000'
          width='24px'
          height='24px'
          viewBox='-2 0 19 19'
        >
          <path d='M14.147 15.488a1.112 1.112 0 0 1-1.567 0l-3.395-3.395a5.575 5.575 0 1 1 1.568-1.568l3.394 3.395a1.112 1.112 0 0 1 0 1.568zm-6.361-3.903a4.488 4.488 0 1 0-1.681.327 4.443 4.443 0 0 0 1.68-.327z' />
        </svg>
      );

    case 'info':
      return (
        <svg
          className={props.className}
          xmlns='http://www.w3.org/2000/svg'
          width='18px'
          height='18px'
          viewBox='0 0 24 24'
          version='1.1'
        >
          <g
            id='页面-1'
            stroke='none'
            stroke-width='1'
            fill='none'
            fill-rule='evenodd'
          >
            <g
              id='System'
              transform='translate(-672.000000, 0.000000)'
              fill-rule='nonzero'
            >
              <g
                id='information_line'
                transform='translate(672.000000, 0.000000)'
              >
                <path
                  d='M24,0 L24,24 L0,24 L0,0 L24,0 Z M12.5934901,23.257841 L12.5819402,23.2595131 L12.5108777,23.2950439 L12.4918791,23.2987469 L12.4918791,23.2987469 L12.4767152,23.2950439 L12.4056548,23.2595131 C12.3958229,23.2563662 12.3870493,23.2590235 12.3821421,23.2649074 L12.3780323,23.275831 L12.360941,23.7031097 L12.3658947,23.7234994 L12.3769048,23.7357139 L12.4804777,23.8096931 L12.4953491,23.8136134 L12.4953491,23.8136134 L12.5071152,23.8096931 L12.6106902,23.7357139 L12.6232938,23.7196733 L12.6232938,23.7196733 L12.6266527,23.7031097 L12.609561,23.275831 C12.6075724,23.2657013 12.6010112,23.2592993 12.5934901,23.257841 L12.5934901,23.257841 Z M12.8583906,23.1452862 L12.8445485,23.1473072 L12.6598443,23.2396597 L12.6498822,23.2499052 L12.6498822,23.2499052 L12.6471943,23.2611114 L12.6650943,23.6906389 L12.6699349,23.7034178 L12.6699349,23.7034178 L12.678386,23.7104931 L12.8793402,23.8032389 C12.8914285,23.8068999 12.9022333,23.8029875 12.9078286,23.7952264 L12.9118235,23.7811639 L12.8776777,23.1665331 C12.8752882,23.1545897 12.8674102,23.1470016 12.8583906,23.1452862 L12.8583906,23.1452862 Z M12.1430473,23.1473072 C12.1332178,23.1423925 12.1221763,23.1452606 12.1156365,23.1525954 L12.1099173,23.1665331 L12.0757714,23.7811639 C12.0751323,23.7926639 12.0828099,23.8018602 12.0926481,23.8045676 L12.108256,23.8032389 L12.3092106,23.7104931 L12.3186497,23.7024347 L12.3186497,23.7024347 L12.3225043,23.6906389 L12.340401,23.2611114 L12.337245,23.2485176 L12.337245,23.2485176 L12.3277531,23.2396597 L12.1430473,23.1473072 Z'
                  id='MingCute'
                  fill-rule='nonzero'
                ></path>
                <path
                  d='M12,2 C17.5228,2 22,6.47715 22,12 C22,17.5228 17.5228,22 12,22 C6.47715,22 2,17.5228 2,12 C2,6.47715 6.47715,2 12,2 Z M12,4 C7.58172,4 4,7.58172 4,12 C4,16.4183 7.58172,20 12,20 C16.4183,20 20,16.4183 20,12 C20,7.58172 16.4183,4 12,4 Z M11.99,10 C12.5478,10 13,10.4522 13,11.01 L13,16.1338 C13.2989,16.3067 13.5,16.6299 13.5,17 C13.5,17.5523 13.0523,18 12.5,18 L12.01,18 C11.4521,18 11,17.5478 11,16.99 L11,12 C10.4477,12 10,11.5523 10,11 C10,10.4477 10.4477,10 11,10 L11.99,10 Z M12,7 C12.5523,7 13,7.44772 13,8 C13,8.55228 12.5523,9 12,9 C11.4477,9 11,8.55228 11,8 C11,7.44772 11.4477,7 12,7 Z'
                  id='形状'
                  fill='#212529'
                ></path>
              </g>
            </g>
          </g>
        </svg>
      );

    case 'cancel':
      return (
        <svg className={props.className}
          xmlns="http://www.w3.org/2000/svg"
          height="26px"
          width="26px"
          viewBox="0 -960 960 960"
          fill={!!color ? color : '#818181'}>
          <path
            d="m480-437.85 122.92 122.93q8.31 8.3 20.89 8.5 12.57.19 21.27-8.5 8.69-8.7 8.69-21.08 0-12.38-8.69-21.08L522.15-480l122.93-122.92q8.3-8.31 8.5-20.89.19-12.57-8.5-21.27-8.7-8.69-21.08-8.69-12.38 0-21.08 8.69L480-522.15 357.08-645.08q-8.31-8.3-20.89-8.5-12.57-.19-21.27 8.5-8.69 8.7-8.69 21.08 0 12.38 8.69 21.08L437.85-480 314.92-357.08q-8.3 8.31-8.5 20.89-.19 12.57 8.5 21.27 8.7 8.69 21.08 8.69 12.38 0 21.08-8.69L480-437.85Zm.07 337.85q-78.84 0-148.21-29.92t-120.68-81.21q-51.31-51.29-81.25-120.63Q100-401.1 100-479.93q0-78.84 29.92-148.21t81.21-120.68q51.29-51.31 120.63-81.25Q401.1-860 479.93-860q78.84 0 148.21 29.92t120.68 81.21q51.31 51.29 81.25 120.63Q860-558.9 860-480.07q0 78.84-29.92 148.21t-81.21 120.68q-51.29 51.31-120.63 81.25Q558.9-100 480.07-100Zm-.07-60q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" />
        </svg>)

    case 'remove':
      return (
        <svg viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>delete_2_line</title> <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="System" transform="translate(-576.000000, -192.000000)" fill-rule="nonzero"> <g id="delete_2_line" transform="translate(576.000000, 192.000000)"> <path d="M24,0 L24,24 L0,24 L0,0 L24,0 Z M12.5934901,23.257841 L12.5819402,23.2595131 L12.5108777,23.2950439 L12.4918791,23.2987469 L12.4918791,23.2987469 L12.4767152,23.2950439 L12.4056548,23.2595131 C12.3958229,23.2563662 12.3870493,23.2590235 12.3821421,23.2649074 L12.3780323,23.275831 L12.360941,23.7031097 L12.3658947,23.7234994 L12.3769048,23.7357139 L12.4804777,23.8096931 L12.4953491,23.8136134 L12.4953491,23.8136134 L12.5071152,23.8096931 L12.6106902,23.7357139 L12.6232938,23.7196733 L12.6232938,23.7196733 L12.6266527,23.7031097 L12.609561,23.275831 C12.6075724,23.2657013 12.6010112,23.2592993 12.5934901,23.257841 L12.5934901,23.257841 Z M12.8583906,23.1452862 L12.8445485,23.1473072 L12.6598443,23.2396597 L12.6498822,23.2499052 L12.6498822,23.2499052 L12.6471943,23.2611114 L12.6650943,23.6906389 L12.6699349,23.7034178 L12.6699349,23.7034178 L12.678386,23.7104931 L12.8793402,23.8032389 C12.8914285,23.8068999 12.9022333,23.8029875 12.9078286,23.7952264 L12.9118235,23.7811639 L12.8776777,23.1665331 C12.8752882,23.1545897 12.8674102,23.1470016 12.8583906,23.1452862 L12.8583906,23.1452862 Z M12.1430473,23.1473072 C12.1332178,23.1423925 12.1221763,23.1452606 12.1156365,23.1525954 L12.1099173,23.1665331 L12.0757714,23.7811639 C12.0751323,23.7926639 12.0828099,23.8018602 12.0926481,23.8045676 L12.108256,23.8032389 L12.3092106,23.7104931 L12.3186497,23.7024347 L12.3186497,23.7024347 L12.3225043,23.6906389 L12.340401,23.2611114 L12.337245,23.2485176 L12.337245,23.2485176 L12.3277531,23.2396597 L12.1430473,23.1473072 Z" id="MingCute" fill-rule="nonzero"> </path> <path d="M14.2792,2 C15.1401,2 15.9044,2.55086 16.1766,3.36754 L16.7208,5 L20,5 C20.5523,5 21,5.44772 21,6 C21,6.55227 20.5523,6.99998 20,7 L19.9975,7.07125 L19.9975,7.07125 L19.1301,19.2137 C19.018,20.7837 17.7117,22 16.1378,22 L7.86224,22 C6.28832,22 4.982,20.7837 4.86986,19.2137 L4.00254,7.07125 C4.00083,7.04735 3.99998,7.02359 3.99996,7 C3.44769,6.99998 3,6.55227 3,6 C3,5.44772 3.44772,5 4,5 L7.27924,5 L7.82339,3.36754 C8.09562,2.55086 8.8599,2 9.72076,2 L14.2792,2 Z M17.9975,7 L6.00255,7 L6.86478,19.0712 C6.90216,19.5946 7.3376,20 7.86224,20 L16.1378,20 C16.6624,20 17.0978,19.5946 17.1352,19.0712 L17.9975,7 Z M10,10 C10.51285,10 10.9355092,10.386027 10.9932725,10.8833761 L11,11 L11,16 C11,16.5523 10.5523,17 10,17 C9.48715929,17 9.06449214,16.613973 9.00672766,16.1166239 L9,16 L9,11 C9,10.4477 9.44771,10 10,10 Z M14,10 C14.5523,10 15,10.4477 15,11 L15,16 C15,16.5523 14.5523,17 14,17 C13.4477,17 13,16.5523 13,16 L13,11 C13,10.4477 13.4477,10 14,10 Z M14.2792,4 L9.72076,4 L9.38743,5 L14.6126,5 L14.2792,4 Z" id="形状" fill="#E4547C"> </path> </g> </g> </g> </g></svg>
      )

    case 'close':
      return (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#0F1729"></path> </g></svg>
      )

    default:
      return null;
  }
};

Icon.propTypes = {
  name: PropTypes.oneOf([
    'text-align-vertical-top',
    'text-align-vertical-middle',
    'text-align-vertical-bottom',
    'stepper-current-step',
    'stepper-done-step',
    'chevron',
    'chevron-blue',
    'scanbit',
    'plus',
    'minus',
    'save',
    'trash',
    'check',
    'copy-pink',
    'refresh',
    'logout',
    'settings',
    'faq',
    'payment',
    'events',
    'groups',
    'group-people',
    'download',
    'excel',
    'stats',
    'tickets',
    'confirm',
    'send-email',
    'map-pin-solid',
    'map-pin-fill',
    'calendar',
    'cake',
    'total-tickets-sold',
    'unique-buyers',
    'unidentified-customers',
    'male',
    'female',
    'average-age',
    'dashboard-stats',
    'transactions',
    'trash-red',
    'options',
    'options-gray',
    'edit',
    'edit-gray',
    'approve',
    'refund',
    'refund-gray',
    'coins',
    'arrow-left',
    'arrow-right',
    'arrow-up-down',
    'clock-dark',
    'clock-white',
    'layer-up',
    'layer-up-to-top',
    'layer-down',
    'layer-down-to-bottom',
    'rubbish-bin',
    'text-style-bold',
    'text-style-italic',
    'text-style-small-caps',
    'text-align-horizontal-left',
    'text-align-horizontal-center',
    'text-align-horizontal-right',
    'history',
    'clear',
    'emails',
    'promoter',
    'search',
    'info',
    'cancel',
    'remove',
    'close',
  ]),
};

export default Icon;
